import { PageRegistrationProperties } from "../../../core/reducers/pageRegistrationReducer.types";
import {
  Box,
  Button,
  Grid,
  IconButton,
  InputBase,
  Modal,
  Paper,
  Tooltip,
  ArrowBackIosNewOutlined as ArrowBackIosNewOutlinedIcon,
  Close as CloseIcon,
  SearchNormal1,
  TickCircle,
  CloseCircle,
  Filter,
  BrushBig,
  Slash,
} from "../../../common/utils/mui-imports";
import {
  AssessmentTypeDTO,
  BulkApproveRemediationTrackerTaskDTO,
  BulkRejectRemediationTrackerTaskDTO,
  DropDownDTO,
  InitialSortStateDTO,
  RemediationTrackerTaskCommentDTO,
  RemediationTrackerTaskDTO,
  RemediationTrackerTaskStatusDTO,
  SortDropDownDTO,
  RemediationTrackerTaskSearchParameter,
  RemediationTrackerTaskGridData,
  ParentChildApprovalDTO,
  ParentChildApprovalRejectionDataDTO,
} from "../../../common/types/common.dto.types";
import {
  EnumGridDataShowRowCount,
  EnumListShowRowCountList,
  EnumPageMode,
  EnumPageType,
  EnumRemediationTrackerTaskColumnType,
  EnumRemediationTrackerTaskStatus,
  EnumSortTypes,
} from "../../../common/enums/common.enums";
import {
  MergeRemediationRequestDTO,
  RemediationTrackerTaskGridDataType,
  RemediationTrackerTaskQuestionsRequestDTO,
  RemediationTrackerTasksPageParametersType,
  RemediationTrackerTasksPageType,
  TaskFilteredSummaryType,
  TaskSelectionType,
  ViewDetailsPopupDataType,
} from "./RemediationTrackerTasksPage.types";
import usePageRegistration from "../../../core/hooks/usePageRegistration";
import { forwardRef, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router";
import { useAppDispatch, useAppSelector } from "../../../core/hooks";
import {
  CheckBulkApproveRemediationTrackerTask,
  CheckBulkRejectRemediationTrackerTask,
  deleteRemediationTrackerTask,
  getRemediationRTrackerTaskQuestionDetails,
  getRemediationTrackerTaskDetails,
  getRemediationTrackerTaskInitialData,
  getRemediationTrackerTaskList,
  mergeRemediationTrackerTask,
  unMergeRemediationTrackerTask,
} from "./RemediationTrackerTasksPage.action";
import { remediationTrackerTasksReducerActions } from "./RemediationTrackerTasksPage.reducer";
import { RemediationTrackerTaskPageParametersType } from "../RemediationTrackerTaskPage/RemediationTrackerTaskPage.types";
import dayjs from "dayjs";
import {
  EnumSystemFunctionTypes,
  EnumSystemFunctions,
} from "../../../core/reducers/functionRights.types";
import { useLocation } from "react-router-dom";
import HPRDropDownMultipleSelect from "../../../components/common/HPRDropDownMultipleSelect/HPRDropDownMultipleSelect";
import HPRTextBox from "../../../components/common/HPRTextBox/HPRTextBox";
import { EnumTextBoxType } from "../../../components/common/HPRTextBox/HPRTextBox.enum";
import HPRDatePicker from "../../../components/common/HPRDatePicker/HPRDatePicker";
import { EnumDateType } from "../../../components/common/HPRDatePicker/HPRDatePicker.enum";
import { NumericFormat, NumericFormatProps } from "react-number-format";
import {
  ListColumn,
  ViewRemediationTrackerTaskListPagination,
  ViewRemediationTrackerTaskListToolBarProps,
} from "../../components/ViewRemediationTrackerTaskList/ViewRemediationTrackerTaskList.types";
import {
  CheckFunctionRights,
  isObjectEqualTo,
} from "../../../common/functions/common.functions";
import HPRDropDownMsGraphMultipleSelect from "../../../components/common/HPRDropDownMultipleSelect/HPRDropDownMsGraphMultipleSelect";
import ViewRemediationTrackerTaskTable from "../../components/ViewRemediationTrackerTaskList/ViewRemediationTrackerTaskTable";
import {
  openPopup,
  updatePopupProps,
} from "../../../components/Popups/Popup.reducer";
import { EnumPopupType } from "../../../components/Popups/Popup.enum";
import { PopupProps } from "../../../components/Popups/PopupProps.types";
import { setPopupOpen } from "../../layouts/main-layout/MainLayout.reducer";

// ==============================|| VIEWS - PAGES - REMEDIATION TRACKER TASKS ||============================== //
// modal popup
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const initialState = {
  GridData: [] as Array<RemediationTrackerTaskGridDataType>,
  TaskSearchParameter: {
    TaskName: "",
    StatusId: 0,
    SelectedActionOwnerIdList: [] as Array<string>,
    SelectedLocationIdList: [] as Array<number>,
    SelectedStandardIdList: [] as Array<number>,
    SelectedPriorityIdList: [] as Array<number>,
    SelectedStatusIdList: [] as Array<number>,
    SelectedInspectionIdList: [] as Array<number>,
    SelectedApproverIdList: [] as Array<number>,
    SelectedPendingApproverIdList: [] as Array<string>,
    SelectedIsCapexRequiredIdList: [] as Array<number>,
    SelectedCapexStatusIdList: [] as Array<number>,
    SelectedAreaOwnerTypeIdList: [] as Array<number>,
    InspectionName: "",
    QuestionNumber: "",
    ActionOwner: "",
    FromDueDate: null,
    ToDueDate: null,
    CapexamountRequired: null,
    CapexnumberAndName: "",
    RemediationTrackerTaskSortBy: {
      Label: "TaskId",
      Value: EnumRemediationTrackerTaskColumnType.TaskId.toString(),
      SortType: EnumSortTypes.Ascending,
    } as SortDropDownDTO,
    ShowTasksAssignedToMe: false,
    ShowTasksPendingMyApproval: false,
    ShowCompletedTasks: false,
    ShowCancelledTasks: false,
    Ernumber: "",
    AssessmentTypeGroupId: "0",

    IsAdvanceSearch: false,
    SelectedPage: 1,
    GridPageSize: EnumGridDataShowRowCount.GridDataShowRowCount_3,
  } as RemediationTrackerTaskSearchParameter,
  SelectedTask: [] as Array<TaskSelectionType>,
  DropDownListFilter: {
    LocationDropDownList: [] as Array<DropDownDTO>,
    InspectionDropDownList: [] as Array<DropDownDTO>,
    StandardDropDownList: [] as Array<DropDownDTO>,
    ActionOwnerDropDownList: [] as Array<DropDownDTO>,
    PriorityDropDownList: [] as Array<DropDownDTO>,
    StatusDropDownList: [] as Array<DropDownDTO>,
    IsCapexRequiredDropDownList: [] as Array<DropDownDTO>,
    CapexStatusDropDownList: [] as Array<DropDownDTO>,
    AreaOwnerTypeDropDownList: [] as Array<DropDownDTO>,
    PendingApproverDropDownList: [] as Array<DropDownDTO>,
  } as RemediationTrackerTaskDTO,
  ShowFilters: false,
  TaskStatusSummaryCount: [] as Array<RemediationTrackerTaskStatusDTO>,
  TaskAssessmentSummary: [] as Array<AssessmentTypeDTO>,
  TaskFilteredSummary: [] as Array<TaskFilteredSummaryType>,
  DataLoading: false,
  MergeTaskBetweenMultipleLocationsAndInspection: false,
  IsFullScreen: false,
  IsEnableCreateMergeTask: false,
  ClearExpandedRows: false,
  ColumnOptions: [] as Array<ListColumn>,
  IsEnableUnMergeTask: false,
  ViewDetailsPopUpData: {
    OpenPopup: false,
    Data: [],
  } as ViewDetailsPopupDataType,
} as RemediationTrackerTasksPageType;

//Numeric field
interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}
const NumericFormatCustom = forwardRef<NumericFormatProps, CustomProps>(
  function NumericFormatCustom(props, ref) {
    const { onChange, ...other } = props;
    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        allowedDecimalSeparators={["%"]}
        decimalScale={2}
        thousandSeparator
      />
    );
  }
);
//End

const RemediationTrackerTasksPage = (props: PageRegistrationProperties) => {
  usePageRegistration(props);
  // create state for RemediationTrackerTasksPageType with initialState values
  const [
    remediationTrackerTasksPageState,
    setRemediationTrackerTasksPageState,
  ] = useState<RemediationTrackerTasksPageType>(initialState);

  //-----standard list heigh ------
  const mainHeading = useRef(null);
  const wrapperCard = useRef(null);
  const searchRef = useRef(null);
  //const checkboxFilter = useRef(null);
  const statusFilter = useRef(null);
  const assessmentTypeRef = useRef(null);
  const advanceFilter = useRef(null);
  //Set Hight
  const [gridHeight, setGridHeight] = useState(0);
  const [advanceFilterHeight, setAdvanceFilterHeight] = useState<number>(0);

  const [approvalData, setApprovalData] = useState<ParentChildApprovalDTO[]>(
    []
  );
  // useEffect(() => {
  //   let advanceFilterHeight = advanceFilter?.current
  //     ? advanceFilter?.current?.offsetHeight + 15
  //     : 0;

  //   let gridHeight =
  //     wrapperCard?.current?.offsetHeight -
  //     searchRef?.current?.offsetHeight -
  //     //checkboxFilter?.current?.offsetHeight -
  //     (assessmentTypeRef?.current?.offsetHeight ?? 100) -
  //     statusFilter?.current?.offsetHeight -
  //     advanceFilterHeight +
  //     45;
  //   setGridHeight(gridHeight);
  //   setAdvanceFilterHeight(advanceFilterHeight);
  //   function handleResize() {
  //     let gridHeight =
  //       wrapperCard?.current?.offsetHeight -
  //       searchRef?.current?.offsetHeight -
  //       (assessmentTypeRef?.current?.offsetHeight ?? 100) -
  //       //checkboxFilter?.current?.offsetHeight -
  //       statusFilter?.current?.offsetHeight -
  //       advanceFilterHeight -
  //       45;
  //     setGridHeight(gridHeight);
  //   }

  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);

  useEffect(() => {
    let advanceFilterHeight = advanceFilter?.current
      ? advanceFilter?.current?.offsetHeight + 15
      : 0;

    let gridHeight =
      wrapperCard?.current?.offsetHeight -
      searchRef?.current?.offsetHeight -
      //checkboxFilter?.current?.offsetHeight -
      (assessmentTypeRef?.current?.offsetHeight ?? 100) -
      statusFilter?.current?.offsetHeight -
      advanceFilterHeight -
      13;
    setAdvanceFilterHeight(advanceFilterHeight);
    setGridHeight(gridHeight);

    function handleResize() {
      let gridHeight =
        wrapperCard?.current?.offsetHeight -
        searchRef?.current?.offsetHeight -
        // checkboxFilter?.current?.offsetHeight -
        (assessmentTypeRef?.current?.offsetHeight ?? 100) -
        statusFilter?.current?.offsetHeight -
        (advanceFilter?.current ? advanceFilter?.current?.offsetHeight : 0) -
        13;
      setGridHeight(gridHeight);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [remediationTrackerTasksPageState?.TaskFilteredSummary]);

  const [initialSortState, setInitialSortState] = useState<
    Array<InitialSortStateDTO>
  >([{} as InitialSortStateDTO]);

  //Advance Search Modal
  const [openAdvanceSearchModel, setOpenAdvanceSearchModel] = useState(false);

  // use for page navigation
  const navigate = useNavigate();

  const dataFetchedRef = useRef(false);

  const dispatch = useAppDispatch();
  const remediationTrackerTasksState = useAppSelector(
    (state) => state.remediationTrackerTasksReducer
  );
  const authState = useAppSelector((state) => state.authReducer);

  const searchTimeout = useRef<NodeJS.Timeout | null>(null);

  // pass parameters from outside to page
  const location = useLocation();
  const parameter: RemediationTrackerTasksPageParametersType = location.state;

  // Set Search Clear Icon
  const [isMouseOver, setIsMouseOver] = useState(false);

  const handleMouseEnter = () => {
    setIsMouseOver(true);
  };

  const handleMouseLeave = () => {
    setIsMouseOver(false);
  };

  const checkSystemFunctionRight = (
    functionId: EnumSystemFunctions,
    functionTypeId: EnumSystemFunctionTypes
  ): boolean => {
    return CheckFunctionRights(
      authState.FunctionRights,
      EnumPageType.RemediationTrackerTasks,
      functionId,
      functionTypeId
    );
  };

  const listOfColumns: Array<ListColumn> = [
    // { ColumnName: "TaskName", ColumnDisplayName: "Task", ColumnHide: false },

    {
      ColumnId: "Identifier-16",
      ColumnName: "Identifier",
      ColumnDisplayName: "Identifier",
      ColumnHide: false,
      DisabledColumnHide: true,
    },
    {
      ColumnId: "LocationName-1",
      ColumnName: "LocationName",
      ColumnDisplayName: "Location",
      ColumnHide: false,
    },
    {
      ColumnId: "AssessmentType-20",
      ColumnName: "AssessmentType",
      ColumnDisplayName: "Assessment Type",
      ColumnHide: false,
    },
    {
      ColumnId: "InspectionName-2",
      ColumnName: "InspectionName",
      ColumnDisplayName: "Inspection",
      ColumnHide: false,
      // DisabledColumnHide: false,
    },
    {
      ColumnId: "InspectionStandardName-3",
      ColumnName: "InspectionStandardName",
      ColumnDisplayName: "Standard",
      ColumnHide: false,
    },
    {
      ColumnId: "Q_No-4",
      ColumnName: "Q_No",
      ColumnDisplayName: "Q.No",
      ColumnHide: false,
      // DisabledColumnHide: false,
    },
    {
      ColumnId: "Piority-8",
      ColumnName: "Piority",
      ColumnDisplayName: "Priority",
      ColumnHide: false,
    },
    {
      ColumnId: "DueDate-9",
      ColumnName: "DueDate",
      ColumnDisplayName: "Due Date",
      ColumnHide: false,
    },
    {
      ColumnId: "Status-6",
      ColumnName: "Status",
      ColumnDisplayName: "Status",
      ColumnHide: false,
    },
    {
      ColumnId: "IsCapexRequired-11",
      ColumnName: "IsCapexRequired",
      ColumnDisplayName: "Is CAPEX Required",
      ColumnHide: true,
    },
    {
      ColumnId: "CapexAmountRequired-12",
      ColumnName: "CapexAmountRequired",
      ColumnDisplayName: "CAPEX Amount Required (M$)",
      ColumnHide: true,
    },
    {
      ColumnId: "Category-15",
      ColumnName: "Category",
      ColumnDisplayName: "Category",
      ColumnHide: true,
    },
    {
      ColumnId: "noOfTask-17",
      ColumnName: "noOfTask",
      ColumnDisplayName: "No.Of Task",
      ColumnHide: true,
    },
    {
      ColumnId: "pendingApprovers-18",
      ColumnName: "pendingApprovers",
      ColumnDisplayName: "Pending Approver(s)",
      ColumnHide: true,
    },
    // {
    //   ColumnId: "approver-10",
    //   ColumnName: "approver",
    //   ColumnDisplayName: "Approver",
    //   ColumnHide: true,
    // },
  ] as Array<ListColumn>;

  const getStatusColorClass = (
    status: EnumRemediationTrackerTaskStatus
  ): string => {
    let colorClass = "";

    if (status === EnumRemediationTrackerTaskStatus.New) {
      colorClass = "blue";
    } else if (status === EnumRemediationTrackerTaskStatus.PendingReviewSME) {
      colorClass = "purple";
    } else if (status === EnumRemediationTrackerTaskStatus.PendingReviewSite) {
      colorClass = "site";
    }
    // else if (status === EnumRemediationTrackerTaskStatus.ReviewCompleted) {
    //   colorClass = "not-started";
    // }
    else if (status === EnumRemediationTrackerTaskStatus.ActionInProgress) {
      colorClass = "yellow";
    } else if (
      status === EnumRemediationTrackerTaskStatus.PendingClosureApproval
    ) {
      colorClass = "pendding-closure";
    } else if (status === EnumRemediationTrackerTaskStatus.Closed) {
      colorClass = "green";
    } else if (status === EnumRemediationTrackerTaskStatus.Overdue) {
      colorClass = "red";
    } else if (status === EnumRemediationTrackerTaskStatus.AutoClosed) {
      colorClass = "auto-closed";
    } else if (status === EnumRemediationTrackerTaskStatus.ClosedAsOverdue) {
      colorClass = "overdue-closed";
    } else if (status === EnumRemediationTrackerTaskStatus.Cancelled) {
      colorClass = "remediation-cancelled";
    }

    return colorClass;
  };

  // Page onload
  useEffect(() => {
    if (dataFetchedRef.current) return;
    dataFetchedRef.current = true;

    setRemediationTrackerTasksPageState(initialState);
    dispatch(
      remediationTrackerTasksReducerActions.resetRemediationTrackerTaskList()
    );

    // set onload page state

    const taskSearchParameter =
      //   parameter?.TaskSearchParameter;
      JSON.parse(localStorage.getItem("taskSearchParameter"));

    const remediationTrackerTaskColumnOptions: Array<ListColumn> = JSON.parse(
      localStorage.getItem("remediationTrackerTaskColumnOptions")
    );

    const initialStateWithSearchParameter = {
      ...initialState,
      GridData: initialState.GridData,
      TaskSearchParameter: {
        ...(taskSearchParameter ??
          ({
            ...initialState.TaskSearchParameter,

            StatusId: taskSearchParameter?.StatusId ?? 0,
          } as RemediationTrackerTaskSearchParameter)),
        SelectedPage: 1,
        GridPageSize: EnumGridDataShowRowCount.GridDataShowRowCount_3,
      },

      ColumnOptions: remediationTrackerTaskColumnOptions ?? listOfColumns,
    } as RemediationTrackerTasksPageType;

    setRemediationTrackerTasksPageState({
      ...initialStateWithSearchParameter,
      TaskSearchParameter: {
        ...initialStateWithSearchParameter.TaskSearchParameter,
        FilterColumnWise: false,
      },
      IsFullScreen:
        parameter?.IsFullScreen ??
        remediationTrackerTasksPageState.IsFullScreen ??
        false,
      ColumnOptions: remediationTrackerTaskColumnOptions ?? listOfColumns,
    });

    // set column option
    dispatch(
      remediationTrackerTasksReducerActions.setRemediationTrackerTaskColumnOptions(
        remediationTrackerTaskColumnOptions ?? listOfColumns
      )
    );

    // dispatch(
    //   remediationTrackerTasksReducerActions.setRemediationTrackerTaskSearchParameter(
    //     initialStateWithSearchParameter?.TaskSearchParameter
    //   )
    // );

    dispatch(getRemediationTrackerTaskInitialData());

    dispatch(
      getRemediationTrackerTaskList({
        ...initialStateWithSearchParameter?.TaskSearchParameter,
        FilterColumnWise: false,
      })
    );

    //clear parameter
    navigate(location.pathname, { replace: true });
  }, []);

  //when reducer state change
  useEffect(() => {
    if (!dataFetchedRef.current) return;
    setRemediationTrackerTasksPageState((values) => {
      return {
        ...values,
        GridData: [...remediationTrackerTasksState?.GridData],
        TaskSearchParameter: {
          ...values.TaskSearchParameter,
          IsAdvanceSearch:
            remediationTrackerTasksState?.TaskSearchParameter?.IsAdvanceSearch,
          SelectedPage:
            remediationTrackerTasksState?.TaskSearchParameter?.SelectedPage,
          GridPageSize:
            remediationTrackerTasksState?.TaskSearchParameter?.GridPageSize,
          TotalRecordsCount:
            remediationTrackerTasksState?.TaskSearchParameter
              ?.TotalRecordsCount,
        },
        TaskStatusSummaryCount:
          remediationTrackerTasksState?.TaskStatusSummaryCount,
        TaskFilteredSummary: remediationTrackerTasksState?.TaskFilteredSummary,
        TaskAssessmentSummary:
          remediationTrackerTasksState?.TaskAssessmentSummary,
      };
    });
  }, [remediationTrackerTasksState]);

  // set when selected Approvers change
  useEffect(() => {
    if (!dataFetchedRef.current) return;
    setRemediationTrackerTasksPageState((values) => {
      return {
        ...values,
        TaskSearchParameter: {
          ...values.TaskSearchParameter,
          SelectedPendingApproverIdList:
            remediationTrackerTasksState.TaskSearchParameter
              .SelectedPendingApproverIdList,
        } as RemediationTrackerTaskSearchParameter,
      };
    });
  }, [
    remediationTrackerTasksState.TaskSearchParameter
      .SelectedPendingApproverIdList,
  ]);

  // call when Assessment type & status summary change
  useEffect(() => {
    if (!dataFetchedRef.current) return;
    setRemediationTrackerTasksPageState((values) => {
      return {
        ...values,
        TaskSearchParameter: {
          ...values.TaskSearchParameter,
          StatusId: remediationTrackerTasksState?.TaskSearchParameter?.StatusId,
          AssessmentTypeGroupId:
            remediationTrackerTasksState?.TaskSearchParameter
              ?.AssessmentTypeGroupId,
        } as RemediationTrackerTaskSearchParameter,
      };
    });
  }, [
    remediationTrackerTasksState?.TaskSearchParameter?.StatusId,
    remediationTrackerTasksState?.TaskSearchParameter?.AssessmentTypeGroupId,
  ]);

  // when selected task reducer state change enabled or disabled merge task between different Locations And Inspection
  // useEffect(() => {
  //   if (!dataFetchedRef.current) return;
  //   dispatch(
  //     remediationTrackerTasksReducerActions.setEnabledCreateMergeTaskButtonState()
  //   );
  // }, [remediationTrackerTasksState.SelectedRemediationTrackerTask]);

  // add to local storage if serachparamter change
  useEffect(() => {
    localStorage.setItem(
      "taskSearchParameter",
      JSON.stringify(remediationTrackerTasksState.TaskSearchParameter)
    );
  }, [remediationTrackerTasksState.TaskSearchParameter]);

  // add to local storage if Column Options change
  useEffect(() => {
    localStorage.setItem(
      "remediationTrackerTaskColumnOptions",
      JSON.stringify(remediationTrackerTasksState.ColumnOptions)
    );
  }, [remediationTrackerTasksState.ColumnOptions]);

  //================================ Search ============================================================

  const onChangeSearchName = (searchValue: string) => {
    setRemediationTrackerTasksPageState((values) => {
      return {
        ...values,
        TaskSearchParameter: {
          ...values.TaskSearchParameter,
          BasicSearchValue: searchValue,
        },
      };
    });

    if (
      !searchValue &&
      !remediationTrackerTasksPageState?.TaskSearchParameter?.IsAdvanceSearch
    ) {
      setRemediationTrackerTasksPageState((values) => {
        return {
          ...values,
          TaskSearchParameter: {
            ...values.TaskSearchParameter,
            SelectedLocationIdList: [] as Array<number>,
            SelectedStandardIdList: [] as Array<number>,
            SelectedPriorityIdList: [] as Array<number>,
            SelectedStatusIdList: [] as Array<number>,
            SelectedInspectionIdList: [] as Array<number>,
            SelectedActionOwnerIdList: [] as Array<string>,
            SelectedApproverIdList: [] as Array<number>,
            SelectedPendingApproverIdList: [] as Array<string>,
            SelectedIsCapexRequiredIdList: [] as Array<number>,
            SelectedCapexStatusIdList: [] as Array<number>,
            SelectedAreaOwnerTypeIdList: [] as Array<number>,
            TaskName: "",
            InspectionName: "",
            QuestionNumber: "",
            ActionOwner: "",
            FromDueDate: null,
            ToDueDate: null,
            CapexamountRequired: null,
            CapexnumberAndName: "",
            Ernumber: "",
            StatusId: 0,

            BasicSearchValue: "",
            IsAdvanceSearch: false,
          } as RemediationTrackerTaskSearchParameter,
        };
      });

      // dispatch(
      //   remediationTrackerTasksReducerActions.resetSelectedRemediationTrackerTask()
      // );

      dispatch(
        getRemediationTrackerTaskList({
          ...remediationTrackerTasksPageState.TaskSearchParameter,
          SelectedLocationIdList: [] as Array<number>,
          SelectedStandardIdList: [] as Array<number>,
          SelectedPriorityIdList: [] as Array<number>,
          SelectedStatusIdList: [] as Array<number>,
          SelectedInspectionIdList: [] as Array<number>,
          SelectedActionOwnerIdList: [] as Array<string>,
          SelectedApproverIdList: [] as Array<number>,
          SelectedPendingApproverIdList: [] as Array<string>,
          SelectedIsCapexRequiredIdList: [] as Array<number>,
          SelectedCapexStatusIdList: [] as Array<number>,
          SelectedAreaOwnerTypeIdList: [] as Array<number>,
          TaskName: "",
          InspectionName: "",
          QuestionNumber: "",
          ActionOwner: "",
          FromDueDate: null,
          ToDueDate: null,
          CapexamountRequired: null,
          CapexnumberAndName: "",
          Ernumber: "",
          StatusId: 0,
          BasicSearchValue: "",
          IsAdvanceSearch: false,
          SelectedPage: 1,
          FilterColumnWise: false,
        } as RemediationTrackerTaskSearchParameter)
      );
    }
  };

  const onChangeTaskSearchParameter = (
    isAdvanceSearch: boolean,
    selectedPage: number,
    pageSize: number,
    resetStatusSummarySelection: boolean
  ) => {
    if (isAdvanceSearch) {
      dispatch(
        remediationTrackerTasksReducerActions.setRemediationTrackerTaskSearchParameter(
          {
            ...remediationTrackerTasksPageState.TaskSearchParameter,
            IsAdvanceSearch: isAdvanceSearch,
            SelectedPage: selectedPage,
            GridPageSize: pageSize,
            FilterColumnWise: false,
          }
        )
      );

      dispatch(
        getRemediationTrackerTaskList({
          ...remediationTrackerTasksPageState.TaskSearchParameter,
          IsAdvanceSearch: isAdvanceSearch,
          SelectedPage: selectedPage,
          GridPageSize: pageSize,
          FilterColumnWise: false,
        })
      );
    } else {
      dispatch(
        remediationTrackerTasksReducerActions.setRemediationTrackerTaskSearchParameter(
          {
            ...remediationTrackerTasksPageState.TaskSearchParameter,
            SelectedLocationIdList: [] as Array<number>,
            SelectedStandardIdList: [] as Array<number>,
            SelectedPriorityIdList: [] as Array<number>,
            SelectedStatusIdList: [] as Array<number>,
            SelectedInspectionIdList: [] as Array<number>,
            SelectedActionOwnerIdList: [] as Array<string>,
            SelectedApproverIdList: [] as Array<number>,
            SelectedPendingApproverIdList: [] as Array<string>,
            SelectedIsCapexRequiredIdList: [] as Array<number>,
            SelectedCapexStatusIdList: [] as Array<number>,
            SelectedAreaOwnerTypeIdList: [] as Array<number>,
            TaskName: "",
            InspectionName: "",
            QuestionNumber: "",
            ActionOwner: "",
            FromDueDate: null,
            ToDueDate: null,
            CapexamountRequired: null,
            CapexnumberAndName: "",
            Ernumber: "",
            StatusId: resetStatusSummarySelection
              ? 0
              : remediationTrackerTasksPageState.TaskSearchParameter.StatusId,

            IsAdvanceSearch: isAdvanceSearch,
            SelectedPage: selectedPage,
          } as RemediationTrackerTaskSearchParameter
        )
      );

      dispatch(
        getRemediationTrackerTaskList({
          ...remediationTrackerTasksPageState.TaskSearchParameter,
          SelectedLocationIdList: [] as Array<number>,
          SelectedStandardIdList: [] as Array<number>,
          SelectedPriorityIdList: [] as Array<number>,
          SelectedStatusIdList: [] as Array<number>,
          SelectedInspectionIdList: [] as Array<number>,
          SelectedActionOwnerIdList: [] as Array<string>,
          SelectedApproverIdList: [] as Array<number>,
          SelectedPendingApproverIdList: [] as Array<string>,
          SelectedIsCapexRequiredIdList: [] as Array<number>,
          SelectedCapexStatusIdList: [] as Array<number>,
          SelectedAreaOwnerTypeIdList: [] as Array<number>,
          TaskName: "",
          InspectionName: "",
          QuestionNumber: "",
          ActionOwner: "",
          FromDueDate: null,
          ToDueDate: null,
          CapexamountRequired: null,
          CapexnumberAndName: "",
          Ernumber: "",
          StatusId: resetStatusSummarySelection
            ? 0
            : remediationTrackerTasksPageState.TaskSearchParameter.StatusId,

          IsAdvanceSearch: isAdvanceSearch,
          SelectedPage: selectedPage,
          GridPageSize: pageSize,
          FilterColumnWise: false,
        } as RemediationTrackerTaskSearchParameter)
      );
    }
  };

  const onKeyPressSearchName = (event: any) => {
    if (event.charCode === 13) {
      event.preventDefault();

      dispatch(
        remediationTrackerTasksReducerActions.resetSelectedRemediationTrackerTask()
      );

      if (
        remediationTrackerTasksPageState.TaskSearchParameter
          ?.BasicSearchValue !==
        remediationTrackerTasksState.TaskSearchParameter?.BasicSearchValue
      ) {
        setRemediationTrackerTasksPageState((values) => {
          return {
            ...values,
            TaskSearchParameter: {
              ...remediationTrackerTasksPageState.TaskSearchParameter,
              SelectedLocationIdList: [] as Array<number>,
              SelectedStandardIdList: [] as Array<number>,
              SelectedPriorityIdList: [] as Array<number>,
              SelectedStatusIdList: [] as Array<number>,
              SelectedInspectionIdList: [] as Array<number>,
              SelectedActionOwnerIdList: [] as Array<string>,
              SelectedApproverIdList: [] as Array<number>,
              SelectedPendingApproverIdList: [] as Array<string>,
              SelectedIsCapexRequiredIdList: [] as Array<number>,
              SelectedCapexStatusIdList: [] as Array<number>,
              SelectedAreaOwnerTypeIdList: [] as Array<number>,
              TaskName: "",
              InspectionName: "",
              QuestionNumber: "",
              ActionOwner: "",
              FromDueDate: null,
              ToDueDate: null,
              CapexamountRequired: null,
              CapexnumberAndName: "",
              Ernumber: "",
              StatusId: 0,

              IsAdvanceSearch: false,
            } as RemediationTrackerTaskSearchParameter,
          };
        });

        onChangeTaskSearchParameter(
          false,
          1, //Default select 1st page,
          remediationTrackerTasksPageState.TaskSearchParameter?.GridPageSize,
          true
        );
      }
    }
  };

  const serachBtnClick = (_IsAdvanceSearch: boolean) => {
    setRemediationTrackerTasksPageState((values) => {
      return {
        ...values,
        TaskSearchParameter: {
          ...remediationTrackerTasksPageState.TaskSearchParameter,
          SelectedLocationIdList: [] as Array<number>,
          SelectedStandardIdList: [] as Array<number>,
          SelectedPriorityIdList: [] as Array<number>,
          SelectedStatusIdList: [] as Array<number>,
          SelectedInspectionIdList: [] as Array<number>,
          SelectedActionOwnerIdList: [] as Array<string>,
          SelectedApproverIdList: [] as Array<number>,
          SelectedPendingApproverIdList: [] as Array<string>,
          SelectedIsCapexRequiredIdList: [] as Array<number>,
          SelectedCapexStatusIdList: [] as Array<number>,
          SelectedAreaOwnerTypeIdList: [] as Array<number>,
          TaskName: "",
          InspectionName: "",
          QuestionNumber: "",
          ActionOwner: "",
          FromDueDate: null,
          ToDueDate: null,
          CapexamountRequired: null,
          CapexnumberAndName: "",
          Ernumber: "",
          StatusId: 0,

          IsAdvanceSearch: false,
        } as RemediationTrackerTaskSearchParameter,
      };
    });

    dispatch(
      remediationTrackerTasksReducerActions.resetSelectedRemediationTrackerTask()
    );

    onChangeTaskSearchParameter(
      false,
      1, //Default select 1st page
      remediationTrackerTasksPageState.TaskSearchParameter?.GridPageSize,
      true
    );
  };

  const onPaginationCallBack = (newPage: number, pageSize: number) => {
    if (
      remediationTrackerTasksState.TaskSearchParameter.GridPageSize !== pageSize
    ) {
      dispatch(
        remediationTrackerTasksReducerActions.setRemediationTrackerTaskSearchParameter(
          {
            ...remediationTrackerTasksPageState.TaskSearchParameter,
            SelectedPage: 1,
            GridPageSize: pageSize,
            FilterColumnWise: false,
          }
        )
      );

      dispatch(
        getRemediationTrackerTaskList({
          ...remediationTrackerTasksPageState.TaskSearchParameter,
          SelectedPage: 1,
          GridPageSize: pageSize,
          FilterColumnWise: false,
        })
      );
    } else if (
      remediationTrackerTasksPageState.TaskSearchParameter.SelectedPage !==
      newPage
    ) {
      onChangeTaskSearchParameter(
        remediationTrackerTasksPageState?.TaskSearchParameter?.IsAdvanceSearch,
        newPage,
        pageSize,
        false
      );
    }
  };

  const handleLocationStandardDropDownListChange = (
    name: string,
    selectedValues: Array<string>
  ) => {
    setRemediationTrackerTasksPageState((values) => {
      return {
        ...values,
        TaskSearchParameter: {
          ...values.TaskSearchParameter,
          [name]:
            selectedValues && selectedValues?.length > 0
              ? selectedValues.map((item) => parseInt(item))
              : ([] as Array<number>),
        } as RemediationTrackerTaskSearchParameter,
      };
    });
  };

  const handleActionOwnerStringDropDownListChange = (
    name: string,
    selectOptions: Array<DropDownDTO>,
    selectedValues: Array<string>
  ) => {
    //reset Action Owner DropDown List because AD search
    dispatch(
      remediationTrackerTasksReducerActions.setDropDownList({
        ...remediationTrackerTasksState.DropDownListFilter,
        ActionOwnerDropDownList: selectOptions,
      })
    );

    setRemediationTrackerTasksPageState((values) => {
      return {
        ...values,
        TaskSearchParameter: {
          ...values.TaskSearchParameter,
          [name]:
            selectedValues && selectedValues?.length > 0
              ? selectedValues.map((item) => item)
              : ([] as Array<string>),
        } as RemediationTrackerTaskSearchParameter,
        DropDownListFilter: {
          ...values.DropDownListFilter,
          ActionOwnerDropDownList: selectOptions,
        },
      };
    });
  };

  const handlePendingApproverStringDropDownListChange = (
    name: string,
    selectOptions: Array<DropDownDTO>,
    selectedValues: Array<string>
  ) => {
    //reset Pending Approver DropDown List because AD search
    dispatch(
      remediationTrackerTasksReducerActions.setDropDownList({
        ...remediationTrackerTasksState.DropDownListFilter,
        PendingApproverDropDownList: selectOptions,
      })
    );

    setRemediationTrackerTasksPageState((values) => {
      return {
        ...values,
        TaskSearchParameter: {
          ...values.TaskSearchParameter,
          [name]:
            selectedValues && selectedValues?.length > 0
              ? selectedValues.map((item) => item)
              : ([] as Array<string>),
        } as RemediationTrackerTaskSearchParameter,
        DropDownListFilter: {
          ...values.DropDownListFilter,
          PendingApproverDropDownList: selectOptions,
        },
      };
    });
  };

  const onDueDateChange = (name: string, value: any) => {
    setRemediationTrackerTasksPageState((values) => {
      return {
        ...values,
        TaskSearchParameter: {
          ...values.TaskSearchParameter,
          [name]: value ? dayjs(value).format("YYYY-MM-DD") : null,
        } as RemediationTrackerTaskSearchParameter,
      };
    });
  };

  const onChangeRemediationTrackerTaskSortBy = (
    selectedSortState: SortDropDownDTO
  ) => {
    if (
      isObjectEqualTo(
        remediationTrackerTasksPageState?.TaskSearchParameter
          ?.RemediationTrackerTaskSortBy,
        selectedSortState
      )
    )
      return;

    setRemediationTrackerTasksPageState((values) => {
      return {
        ...values,
        TaskSearchParameter: {
          ...values.TaskSearchParameter,
          RemediationTrackerTaskSortBy: selectedSortState,
        } as RemediationTrackerTaskSearchParameter,
      };
    });

    if (remediationTrackerTasksState.TaskSearchParameter?.FilterColumnWise) {
      dispatch(remediationTrackerTasksReducerActions.setDataLoading(true));
      dispatch(
        getRemediationTrackerTaskList({
          ...remediationTrackerTasksPageState.TaskSearchParameter,
          RemediationTrackerTaskSortBy: selectedSortState,

          SelectedPage: 1,
          FilterColumnWise: true,
        })
      );
    } else {
      dispatch(
        getRemediationTrackerTaskList({
          ...remediationTrackerTasksPageState.TaskSearchParameter,
          RemediationTrackerTaskSortBy: selectedSortState,

          SelectedPage: 1,
          FilterColumnWise: false,
        })
      );
    }
  };

  const onclickRemoveAllFilters = () => {
    setRemediationTrackerTasksPageState((values) => {
      return {
        ...values,
        TaskSearchParameter: {
          ...values.TaskSearchParameter,
          SelectedLocationIdList: [] as Array<number>,
          SelectedStandardIdList: [] as Array<number>,
          SelectedPriorityIdList: [] as Array<number>,
          SelectedStatusIdList: [] as Array<number>,
          SelectedInspectionIdList: [] as Array<number>,
          SelectedActionOwnerIdList: [] as Array<string>,
          SelectedApproverIdList: [] as Array<number>,
          SelectedPendingApproverIdList: [] as Array<string>,
          SelectedIsCapexRequiredIdList: [] as Array<number>,
          SelectedCapexStatusIdList: [] as Array<number>,
          SelectedAreaOwnerTypeIdList: [] as Array<number>,
          TaskName: "",
          InspectionName: "",
          QuestionNumber: "",
          ActionOwner: "",
          FromDueDate: null,
          ToDueDate: null,
          CapexamountRequired: null,
          CapexnumberAndName: "",
          Ernumber: "",
          StatusId: 0,

          BasicSearchValue: "",
          IsAdvanceSearch: false,
          SelectedPage: 1,
        } as RemediationTrackerTaskSearchParameter,
      };
    });

    dispatch(
      remediationTrackerTasksReducerActions.resetSelectedRemediationTrackerTask()
    );

    dispatch(
      getRemediationTrackerTaskList({
        ...remediationTrackerTasksPageState.TaskSearchParameter,
        SelectedLocationIdList: [] as Array<number>,
        SelectedStandardIdList: [] as Array<number>,
        SelectedPriorityIdList: [] as Array<number>,
        SelectedStatusIdList: [] as Array<number>,
        SelectedInspectionIdList: [] as Array<number>,
        SelectedActionOwnerIdList: [] as Array<string>,
        SelectedApproverIdList: [] as Array<number>,
        SelectedPendingApproverIdList: [] as Array<string>,
        SelectedIsCapexRequiredIdList: [] as Array<number>,
        SelectedCapexStatusIdList: [] as Array<number>,
        SelectedAreaOwnerTypeIdList: [] as Array<number>,
        TaskName: "",
        InspectionName: "",
        QuestionNumber: "",
        ActionOwner: "",
        FromDueDate: null,
        ToDueDate: null,
        CapexamountRequired: null,
        CapexnumberAndName: "",
        Ernumber: "",
        StatusId: 0,

        BasicSearchValue: "",
        IsAdvanceSearch: false,
        SelectedPage: 1,
        FilterColumnWise: false,
      } as RemediationTrackerTaskSearchParameter)
    );
  };

  const onclickRemoveAllAdvancedFilters = () => {
    setRemediationTrackerTasksPageState((values) => {
      return {
        ...values,
        TaskSearchParameter: {
          ...values.TaskSearchParameter,
          SelectedLocationIdList: [] as Array<number>,
          SelectedStandardIdList: [] as Array<number>,
          SelectedPriorityIdList: [] as Array<number>,
          SelectedStatusIdList: [] as Array<number>,
          SelectedInspectionIdList: [] as Array<number>,
          SelectedActionOwnerIdList: [] as Array<string>,
          SelectedApproverIdList: [] as Array<number>,
          SelectedPendingApproverIdList: [] as Array<string>,
          SelectedIsCapexRequiredIdList: [] as Array<number>,
          SelectedCapexStatusIdList: [] as Array<number>,
          SelectedAreaOwnerTypeIdList: [] as Array<number>,
          TaskName: "",
          InspectionName: "",
          QuestionNumber: "",
          ActionOwner: "",
          FromDueDate: null,
          ToDueDate: null,
          CapexamountRequired: null,
          CapexnumberAndName: "",
          Ernumber: "",

          IsAdvanceSearch: false,
        } as RemediationTrackerTaskSearchParameter,
      };
    });

    dispatch(
      remediationTrackerTasksReducerActions.resetSelectedRemediationTrackerTask()
    );

    dispatch(
      getRemediationTrackerTaskList({
        ...remediationTrackerTasksPageState.TaskSearchParameter,
        SelectedLocationIdList: [] as Array<number>,
        SelectedStandardIdList: [] as Array<number>,
        SelectedPriorityIdList: [] as Array<number>,
        SelectedStatusIdList: [] as Array<number>,
        SelectedInspectionIdList: [] as Array<number>,
        SelectedActionOwnerIdList: [] as Array<string>,
        SelectedApproverIdList: [] as Array<number>,
        SelectedPendingApproverIdList: [] as Array<string>,
        SelectedIsCapexRequiredIdList: [] as Array<number>,
        SelectedCapexStatusIdList: [] as Array<number>,
        SelectedAreaOwnerTypeIdList: [] as Array<number>,
        TaskName: "",
        InspectionName: "",
        QuestionNumber: "",
        ActionOwner: "",
        FromDueDate: null,
        ToDueDate: null,
        CapexamountRequired: null,
        CapexnumberAndName: "",
        Ernumber: "",

        SelectedPage: 1,
        IsAdvanceSearch: false,
        FilterColumnWise: false,
      } as RemediationTrackerTaskSearchParameter)
    );
  };

  const onclickAdvanceSearchOpen = () => {
    setOpenAdvanceSearchModel(true);
  };

  const onclickAdvanceSearchClose = () => {
    //clear not apply filters
    setRemediationTrackerTasksPageState((values) => {
      return {
        ...values,
        TaskSearchParameter: remediationTrackerTasksState.TaskSearchParameter,
      };
    });

    setOpenAdvanceSearchModel(false);
  };

  const onclickAdvanceSearchbtn = () => {
    let stateObj = { ...remediationTrackerTasksPageState };

    stateObj.TaskSearchParameter = {
      ...stateObj.TaskSearchParameter,
      StatusId: 0,
    };

    dispatch(
      remediationTrackerTasksReducerActions.resetSelectedRemediationTrackerTask()
    );

    dispatch(
      getRemediationTrackerTaskList({
        ...stateObj.TaskSearchParameter,
        BasicSearchValue: "",
        SelectedPage: 1,
        IsAdvanceSearch: true,
        FilterColumnWise: false,
      })
    );

    setRemediationTrackerTasksPageState((values) => {
      return {
        ...values,
        TaskSearchParameter: {
          ...values.TaskSearchParameter,
          BasicSearchValue: "",
          ...values.TaskSearchParameter,
          StatusId: 0,
        } as RemediationTrackerTaskSearchParameter,
      };
    });

    setOpenAdvanceSearchModel(false);
  };

  const onSearchTextBoxChange = (name: string, newValue: string) => {
    setRemediationTrackerTasksPageState((values) => {
      return {
        ...values,
        TaskSearchParameter: {
          ...values.TaskSearchParameter,
          [name]: newValue || "",
        } as RemediationTrackerTaskSearchParameter,
      };
    });
  };

  const onclickRemediationTrackerTaskDetailsCallBack = (
    parentTaskId: number
  ) => {
    dispatch(getRemediationTrackerTaskDetails(parentTaskId));
  };

  const handleSummaryClick = (name: string, value: string | number) => {
    let searchedValue =
      remediationTrackerTasksState.TaskSearchParameter.BasicSearchValue;

    let searchParameters = {
      ...remediationTrackerTasksPageState.TaskSearchParameter,
      [name]: value,
    } as RemediationTrackerTaskSearchParameter;

    // set status summary defualt
    if (name === "AssessmentTypeGroupId") {
      searchParameters = {
        ...searchParameters,
        StatusId: 0,
      } as RemediationTrackerTaskSearchParameter;
    }

    setRemediationTrackerTasksPageState((values) => {
      return {
        ...values,
        TaskSearchParameter: searchParameters,
      };
    });

    dispatch(
      remediationTrackerTasksReducerActions.resetSelectedRemediationTrackerTask()
    );

    dispatch(
      getRemediationTrackerTaskList({
        ...searchParameters,
        FilterColumnWise: false,
        SelectedPage: 1,
      })
    );
    if (!searchedValue || searchedValue?.trim() == "") {
      setRemediationTrackerTasksPageState((values) => {
        return {
          ...values,
          TaskSearchParameter: {
            ...values.TaskSearchParameter,
            BasicSearchValue: "",
          },
        };
      });
    }
  };

  //================================ End Search ============================================================

  //===================Callback function<Start>============================================================

  const onCheckAllCheckBoxClickedCallBack = (isChecked: boolean) => {
    const { SelectedTask: selectedTasks = [], GridData: gridData = [] } =
      remediationTrackerTasksState;

    let updatedSelectedTasks: Array<TaskSelectionType> = [];

    if (!isChecked) {
      const gridParentTaskId = [
        ...gridData.map((data) => data.ParentTask.ParentTaskId),
      ];
      updatedSelectedTasks = [
        ...selectedTasks?.filter(
          (filter) => !gridParentTaskId.includes(filter.ParentTaskId)
        ),
      ];
    } else {
      const ignoreSelectStatus = new Set([
        EnumRemediationTrackerTaskStatus.Closed,
        EnumRemediationTrackerTaskStatus.ClosedAsOverdue,
        EnumRemediationTrackerTaskStatus.Cancelled,
      ]);

      updatedSelectedTasks = [
        ...gridData
          ?.filter(
            (filter) => !ignoreSelectStatus.has(filter.ParentTask?.StatusId)
          )
          ?.map((task) => {
            const allChildIds =
              task?.ChildTask?.filter(
                (childTask) => !ignoreSelectStatus.has(childTask.StatusId)
              ).map((childTask) => childTask.ChildTaskId) ?? [];

            return {
              ParentTaskId: task.ParentTask?.ParentTaskId,
              ChildTaskIds: [...allChildIds],
            } as TaskSelectionType;
          }),
      ];
    }

    dispatch(
      remediationTrackerTasksReducerActions.setTaskSelectionChange([
        ...updatedSelectedTasks,
      ])
    );
  };

  const onclickCreateMergeNewTask = () => {
    if (remediationTrackerTasksState.IsEnableCreateMergeTask) {
      let remediationTaskIdList =
        remediationTrackerTasksState.SelectedTask?.map(
          (item) => item.ParentTaskId
        ) ?? [];

      const request: MergeRemediationRequestDTO = {
        RemediationTrackerTasksIdList: remediationTaskIdList,
      };

      dispatch(mergeRemediationTrackerTask(request));
    }
  };

  const onclickUnMergeTask = () => {
    if (remediationTrackerTasksState.IsEnableUnMergeTask) {
      dispatch(
        openPopup({
          Open: true,
          BodyText:
            "You've chosen to unmerge this task. This process may take a few minutes. <br />Click 'Yes' to confirm.",
          HeaderText: "Confirmation",
          PopupType: EnumPopupType.YesNoConfirmation,
          DisableBackdropClose: true,
          YesBtnClick() {
            let remediationTaskIdList =
              remediationTrackerTasksState.SelectedTask?.map(
                (item) => item.ParentTaskId
              ) ?? [];

            dispatch(unMergeRemediationTrackerTask(remediationTaskIdList[0]));
          },
        } as PopupProps)
      );
    }
  };

  const onclickAddNewTaskCallBack = (task: RemediationTrackerTaskGridData) => {
    let inspectionQuestionIdList: Array<number> =
      // task?.RemediationTrackerTaskQuestions?.map((item) => {
      //   return item.InspectionQuestion?.Id;
      // }) ??

      [task.InspectionQuestionId];

    navigate("/remediationTrackerTask", {
      state: {
        PageMode: EnumPageMode.AddMode,
        InspectionQuestionIdList: inspectionQuestionIdList,
        TaskSearchParameter: remediationTrackerTasksState?.TaskSearchParameter,
        IsFullScreen: remediationTrackerTasksPageState.IsFullScreen,
        ColumnOptions: remediationTrackerTasksState.ColumnOptions ?? [],
        RemediationTrackerTaskIdList: [task.ParentTaskId],
        RemediationTrackerTaskId: task.ParentTaskId,
      } as RemediationTrackerTaskPageParametersType,
    });

    // clear state
    dispatch(
      remediationTrackerTasksReducerActions.resetRemediationTrackerTaskList()
    );
  };

  const onClickViewOrEditTaskCallBack = (taskId: number) => {
    navigate("/remediationTrackerTask", {
      state: {
        PageMode: EnumPageMode.ViewMode,
        RemediationTrackerTaskId: taskId,
        TaskSearchParameter: remediationTrackerTasksState?.TaskSearchParameter,
        IsFullScreen: remediationTrackerTasksPageState.IsFullScreen,
        ColumnOptions: remediationTrackerTasksState.ColumnOptions ?? [],
      } as RemediationTrackerTaskPageParametersType,
    });

    //clear state
    dispatch(
      remediationTrackerTasksReducerActions.resetRemediationTrackerTaskList()
    );
  };
  //-----standard list heigh ------
  // const remWrapper = useRef(null);
  // const searchRef = useRef(null);
  // const optionBar = useRef(null);
  // const pagination = useRef(null);

  //Set Hight
  // const [listHeight, setListHeight] = useState(0);
  // const [calendarHeight, setCalendarHeight] = useState(0);

  //-----Page load-----
  // useEffect(() => {
  //   let listHeight =
  //     wrapperCard.current?.innerHeight -
  //     searchRef.current?.offsetHeight -
  //     optionBar.current?.offsetHeight -
  //     pagination.current?.offsetHeight -
  //     20;
  //   setListHeight(listHeight);

  const deleteRemediationTrackerTaskCallBack = (taskId: number) => {
    dispatch(deleteRemediationTrackerTask(taskId));
  };

  const onClickRemoveFiltersCallBack = (
    filterField: TaskFilteredSummaryType
  ) => {
    if (filterField.Field === "DueDate") {
      setRemediationTrackerTasksPageState((values) => {
        return {
          ...values,
          TaskSearchParameter: {
            ...values.TaskSearchParameter,
            FromDueDate: filterField.DefaultValue,
            ToDueDate: filterField.DefaultValue,
            StatusId: 0,

            SelectedPage: 1,
          } as RemediationTrackerTaskSearchParameter,
        };
      });

      dispatch(
        getRemediationTrackerTaskList({
          ...remediationTrackerTasksPageState.TaskSearchParameter,
          FromDueDate: filterField.DefaultValue,
          ToDueDate: filterField.DefaultValue,
          StatusId: 0,

          SelectedPage: 1,
          FilterColumnWise: false,
        } as RemediationTrackerTaskSearchParameter)
      );
    } else {
      setRemediationTrackerTasksPageState((values) => {
        return {
          ...values,
          TaskSearchParameter: {
            ...values.TaskSearchParameter,
            [filterField.Field]: filterField.DefaultValue,
            StatusId: 0,

            SelectedPage: 1,
          } as RemediationTrackerTaskSearchParameter,
        };
      });

      dispatch(
        getRemediationTrackerTaskList({
          ...remediationTrackerTasksPageState.TaskSearchParameter,
          [filterField.Field]: filterField.DefaultValue,
          StatusId: 0,

          SelectedPage: 1,
          FilterColumnWise: false,
        } as RemediationTrackerTaskSearchParameter)
      );
    }

    dispatch(
      remediationTrackerTasksReducerActions.resetSelectedRemediationTrackerTask()
    );
  };

  const onClickRefreshBtnCallBack = () => {
    dispatch(remediationTrackerTasksReducerActions.setDataLoading(true));

    dispatch(
      getRemediationTrackerTaskList({
        ...remediationTrackerTasksPageState.TaskSearchParameter,
        FilterColumnWise: false,
        // SelectedPage: 1,
      })
    );
  };

  const onIsFullScreenChangeCallBack = (isFullScreen: boolean) => {
    setRemediationTrackerTasksPageState((values) => {
      return {
        ...values,
        IsFullScreen: isFullScreen,
      };
    });
  };

  const onChangeColumnOptionsCallBack = (columnOptions: Array<ListColumn>) => {
    dispatch(
      remediationTrackerTasksReducerActions.setRemediationTrackerTaskColumnOptions(
        columnOptions ?? []
      )
    );
  };

  //===================Callback function<End>============================================================

  const BacktnOnclick = () => {
    navigate("/");
  };

  const perPageList: Array<DropDownDTO> = [
    {
      Label: "5",
      Value: EnumListShowRowCountList.ListShowRowCountPerPage_1.toString(),
    },
    {
      Label: "10",
      Value: EnumListShowRowCountList.ListShowRowCountPerPage_2.toString(),
    },
    {
      Label: "15",
      Value: EnumListShowRowCountList.ListShowRowCountPerPage_3.toString(),
    },
    {
      Label: "20",
      Value: EnumListShowRowCountList.ListShowRowCountPerPage_4.toString(),
    },
    {
      Label: "25",
      Value: EnumListShowRowCountList.ListShowRowCountPerPage_5.toString(),
    },
  ];

  //sort by option list
  const sortByItemList = [
    {
      Label: "Location",
      Value: EnumRemediationTrackerTaskColumnType.Location.toString(),
      SortType: EnumSortTypes.Ascending,
    },
    {
      Label: "Inspection",
      Value: EnumRemediationTrackerTaskColumnType.Inspection.toString(),
      SortType: EnumSortTypes.Ascending,
    },
    {
      Label: "Standard",
      Value: EnumRemediationTrackerTaskColumnType.Standard.toString(),
      SortType: EnumSortTypes.Ascending,
    },
    {
      Label: "Q.No",
      Value: EnumRemediationTrackerTaskColumnType.QuestionNumber.toString(),
      SortType: EnumSortTypes.Ascending,
    },
    {
      Label: "Task Description",
      Value: EnumRemediationTrackerTaskColumnType.TaskName.toString(),
      SortType: EnumSortTypes.Ascending,
    },
    {
      Label: "Status",
      Value: EnumRemediationTrackerTaskColumnType.Status.toString(),
      SortType: EnumSortTypes.Ascending,
    },
    {
      Label: "Action Owner",
      Value: EnumRemediationTrackerTaskColumnType.ActionOwner.toString(),
      SortType: EnumSortTypes.Ascending,
    },
    {
      Label: "Priority",
      Value: EnumRemediationTrackerTaskColumnType.Priority.toString(),
      SortType: EnumSortTypes.Ascending,
    },
    {
      Label: "Due Date",
      Value: EnumRemediationTrackerTaskColumnType.DueDate.toString(),
      SortType: EnumSortTypes.Ascending,
    },
    // {
    //   Label: "Approver",
    //   Value: EnumRemediationTrackerTaskColumnType.Approver.toString(),
    //   SortType: EnumSortTypes.Ascending,
    // },
    {
      Label: "Is CAPEX Required",
      Value: EnumRemediationTrackerTaskColumnType.IsCapexrequired.toString(),
      SortType: EnumSortTypes.Ascending,
    },
    {
      Label: "CAPEX Amount Required (M$)",
      Value:
        EnumRemediationTrackerTaskColumnType.CapexamountRequired.toString(),
      SortType: EnumSortTypes.Ascending,
    },
    {
      Label: "CAPEX Number And Name",
      Value: EnumRemediationTrackerTaskColumnType.CapexnumberAndName.toString(),
      SortType: EnumSortTypes.Ascending,
    },
    {
      Label: "CAPEX Status",
      Value: EnumRemediationTrackerTaskColumnType.Capexstatus.toString(),
      SortType: EnumSortTypes.Ascending,
    },
    {
      Label: "Category", // "Area Owner",
      Value: EnumRemediationTrackerTaskColumnType.AreaOwner.toString(),
      SortType: EnumSortTypes.Ascending,
    },
    {
      Label: "Pending Approver(s)",
      Value: EnumRemediationTrackerTaskColumnType.PendingApprovers.toString(),
      SortType: EnumSortTypes.Ascending,
    },
  ];

  const showHideClearBtn = (): boolean => {
    if (
      remediationTrackerTasksState?.TaskSearchParameter?.SelectedLocationIdList
        ?.length !== 0 ||
      remediationTrackerTasksState?.TaskSearchParameter
        ?.SelectedInspectionIdList?.length !== 0 ||
      remediationTrackerTasksState?.TaskSearchParameter?.SelectedStandardIdList
        ?.length !== 0 ||
      remediationTrackerTasksState?.TaskSearchParameter
        ?.SelectedActionOwnerIdList?.length !== 0 ||
      remediationTrackerTasksState?.TaskSearchParameter?.SelectedPriorityIdList
        ?.length !== 0 ||
      remediationTrackerTasksState?.TaskSearchParameter?.SelectedStatusIdList
        ?.length !== 0 ||
      remediationTrackerTasksState?.TaskSearchParameter
        ?.SelectedActionOwnerIdList?.length !== 0 ||
      remediationTrackerTasksState?.TaskSearchParameter?.SelectedApproverIdList
        ?.length !== 0 ||
      remediationTrackerTasksState?.TaskSearchParameter
        ?.SelectedPendingApproverIdList?.length !== 0 ||
      remediationTrackerTasksState?.TaskSearchParameter
        ?.SelectedIsCapexRequiredIdList?.length !== 0 ||
      remediationTrackerTasksState?.TaskSearchParameter
        ?.SelectedCapexStatusIdList?.length !== 0 ||
      remediationTrackerTasksState?.TaskSearchParameter
        ?.SelectedAreaOwnerTypeIdList?.length !== 0 ||
      remediationTrackerTasksState?.TaskSearchParameter?.QuestionNumber ||
      remediationTrackerTasksState?.TaskSearchParameter?.TaskName ||
      remediationTrackerTasksState?.TaskSearchParameter?.FromDueDate ||
      remediationTrackerTasksState?.TaskSearchParameter?.ToDueDate ||
      remediationTrackerTasksState?.TaskSearchParameter?.CapexamountRequired ||
      remediationTrackerTasksState?.TaskSearchParameter?.CapexnumberAndName ||
      remediationTrackerTasksState?.TaskSearchParameter?.Ernumber
    ) {
      return true;
    } else {
      return false;
    }
  };

  const handleFilterCheckboxChange = (name: string, checked: boolean) => {
    let {
      ShowTasksAssignedToMe,
      ShowTasksPendingMyApproval,
      ShowCompletedTasks,
      ShowCancelledTasks,
    } =
      remediationTrackerTasksPageState.TaskSearchParameter ??
      ({} as RemediationTrackerTaskDTO);

    if (name === "ShowTasksAssignedToMe") {
      ShowTasksAssignedToMe = checked;
      ShowTasksPendingMyApproval = false;
      ShowCompletedTasks = false;
      ShowCancelledTasks = false;
    } else if (name === "ShowTasksPendingMyApproval") {
      ShowTasksAssignedToMe = false;
      ShowTasksPendingMyApproval = checked;
      ShowCompletedTasks = false;
      ShowCancelledTasks = false;
    } else if (name === "ShowCompletedTasks") {
      ShowCompletedTasks = checked;
      ShowTasksAssignedToMe = false;
      ShowTasksPendingMyApproval = false;
    } else if (name === "ShowCancelledTasks") {
      ShowCancelledTasks = checked;
      ShowTasksAssignedToMe = false;
      ShowTasksPendingMyApproval = false;
    }

    setRemediationTrackerTasksPageState((values) => {
      return {
        ...values,
        TaskSearchParameter: {
          ...values.TaskSearchParameter,
          ShowTasksAssignedToMe: ShowTasksAssignedToMe,
          ShowTasksPendingMyApproval: ShowTasksPendingMyApproval,
          ShowCompletedTasks: ShowCompletedTasks,
          ShowCancelledTasks: ShowCancelledTasks,
          StatusId: 0,
        } as RemediationTrackerTaskSearchParameter,
      };
    });

    dispatch(
      getRemediationTrackerTaskList({
        ...remediationTrackerTasksPageState.TaskSearchParameter,
        ShowTasksAssignedToMe: ShowTasksAssignedToMe,
        ShowTasksPendingMyApproval: ShowTasksPendingMyApproval,
        ShowCompletedTasks: ShowCompletedTasks,
        ShowCancelledTasks: ShowCancelledTasks,
        StatusId: 0,

        SelectedPage: 1,
        FilterColumnWise: false,
      } as RemediationTrackerTaskSearchParameter)
    );
  };

  // Approve selected task(s)
  const onclickApproveRemediationTrackerTask = () => {
    const obj = {
      ParentChildDataList: approvalData,
      SearchParameters: remediationTrackerTasksState.TaskSearchParameter,
    } as ParentChildApprovalRejectionDataDTO;
    // dispatch(
    //   openPopup({
    //     Open: true,
    //     BodyText: "Are you sure you want to approve the selected  task(s)?",
    //     HeaderText: "Confirmation",
    //     PopupType: EnumPopupType.YesNoConfirmation,
    //     YesBtnClick() {
    dispatch(CheckBulkApproveRemediationTrackerTask(obj));
    //     },
    //   })
    // );
  };

  // reject popup confirm handle
  const handleRejectPopupYesClick = async (
    value: string,
    closePopup: () => void
  ) => {
    if (value.trim().length > 0) {
      const parentChildRejectionData: ParentChildApprovalRejectionDataDTO = {
        ParentChildDataList: approvalData,
        RemediationTrackerTaskRejectReason: {
          Id: 0,
          Comment: value,
        } as RemediationTrackerTaskCommentDTO,
        SearchParameters: remediationTrackerTasksState.TaskSearchParameter,
      };

      dispatch(CheckBulkRejectRemediationTrackerTask(parentChildRejectionData));
      closePopup();
    } else {
      dispatch(
        updatePopupProps({
          ErrorMessage: "Please enter a reason for rejection",
        })
      );
    }
  };

  // Reject selected task(s)
  const onclickRejectRemediationTrackerTask = () => {
    const parentChildRejectionData: ParentChildApprovalRejectionDataDTO = {
      ParentChildDataList: approvalData,
      RemediationTrackerTaskRejectReason: {
        Id: 0,
        Comment: "",
      } as RemediationTrackerTaskCommentDTO,
      SearchParameters: remediationTrackerTasksState.TaskSearchParameter,
    };

    dispatch(CheckBulkRejectRemediationTrackerTask(parentChildRejectionData));

    // dispatch(
    //   openPopup({
    //     Open: true,
    //     HeaderText: "Reason for Rejection",
    //     LableText: "Reason for Rejection",
    //     InputText: "",
    //     Required: true,
    //     CancelButtonText: "Discard",
    //     YesButtonText: "Confirm",
    //     PopupType: EnumPopupType.TextInputPopup,
    //     InputTextCount: 100,
    //     ActionBtnClick: (value, closePopup) => {
    //       handleRejectPopupYesClick(value, closePopup);
    //     },
    //     CloseBtnClick: () => {
    //       setPopupOpen(false);
    //     },
    //     DisableBackdropClose: true,
    //   } as PopupProps)
    // );
  };

  const taskGridDataList = useMemo(() => {
    return [...remediationTrackerTasksPageState?.GridData];
  }, [remediationTrackerTasksPageState?.GridData]);

  const handleTaskSelectionChange = (
    parentTaskId: number,
    childTaskId: number,
    isSelected: boolean,
    isParentTaskClick: boolean
  ) => {
    const { SelectedTask: selectedTasks = [], GridData: gridData = [] } =
      remediationTrackerTasksState;

    let updatedSelectedTasks: Array<TaskSelectionType> = [...selectedTasks];

    const parentIndex = updatedSelectedTasks.findIndex(
      (task) => task.ParentTaskId === parentTaskId
    );

    const parentExists = parentIndex !== -1;

    // check is approver
    const gridParent = gridData.find(
      (item) => item.ParentTask?.ParentTaskId === parentTaskId
    );

    const isApprover =
      (gridParent.ParentTask?.IsApprover &&
        gridParent.ParentTask?.NoOfChildTask === 1) ||
      gridParent.ChildTask?.some((some) => some.IsApprover);

    if (isParentTaskClick && !isSelected) {
      updatedSelectedTasks = updatedSelectedTasks.filter(
        (task) => task.ParentTaskId !== parentTaskId
      );
    } else if (isParentTaskClick && isSelected) {
      const ignoreSelectStatus = new Set([
        EnumRemediationTrackerTaskStatus.Closed,
        EnumRemediationTrackerTaskStatus.ClosedAsOverdue,
        EnumRemediationTrackerTaskStatus.Cancelled,
      ]);
      const allChildIds =
        gridParent?.ChildTask?.filter(
          (task) => !ignoreSelectStatus.has(task.StatusId)
        ).map((task) => task.ChildTaskId) ?? [];

      if (parentExists) {
        updatedSelectedTasks[parentIndex] = {
          ParentTaskId: parentTaskId,
          ChildTaskIds: allChildIds,
          IsApprover: isApprover,
        };
      } else {
        updatedSelectedTasks.push({
          ParentTaskId: parentTaskId,
          ChildTaskIds: allChildIds,
          IsApprover: isApprover,
        });
      }
    } else if (parentExists) {
      const existing = updatedSelectedTasks[parentIndex];

      if (isSelected) {
        if (!existing.ChildTaskIds.includes(childTaskId)) {
          updatedSelectedTasks[parentIndex] = {
            ...existing,
            ChildTaskIds: [...existing.ChildTaskIds, childTaskId],
          };
        }
      } else {
        const newChildIds = existing.ChildTaskIds.filter(
          (id) => id !== childTaskId
        );

        if (newChildIds.length === 0) {
          updatedSelectedTasks.splice(parentIndex, 1);
        } else {
          updatedSelectedTasks[parentIndex] = {
            ...existing,
            ChildTaskIds: newChildIds,
          };
        }
      }
    } else if (isSelected && childTaskId !== 0) {
      updatedSelectedTasks.push({
        ParentTaskId: parentTaskId,
        ChildTaskIds: [childTaskId],
        IsApprover: isApprover,
      });
    }

    dispatch(
      remediationTrackerTasksReducerActions.setTaskSelectionChange([
        ...updatedSelectedTasks,
      ])
    );
  };

  // Enable/Disable Merge and UnMerge button based on selection
  useEffect(() => {
    const gridData = remediationTrackerTasksState.GridData;
    const selectedTasks = remediationTrackerTasksState.SelectedTask;

    let updatedTasks: Array<TaskSelectionType> = [...selectedTasks];

    if (updatedTasks.length === 1) {
      const remediation = gridData.find(
        (i) => i.ParentTask?.ParentTaskId === updatedTasks[0].ParentTaskId
      );
      if (remediation && remediation.ParentTask.IsMergeTask) {
        if (remediation.ParentTask.TaskIsChecked) {
          dispatch(
            remediationTrackerTasksReducerActions.setEnableUnMergeTask(true)
          );
        } else {
          dispatch(
            remediationTrackerTasksReducerActions.setEnableUnMergeTask(false)
          );
        }
      } else {
        dispatch(
          remediationTrackerTasksReducerActions.setEnableUnMergeTask(false)
        );
      }
      dispatch(
        remediationTrackerTasksReducerActions.setEnableCreateMergeTask(false)
      );
    } else if (updatedTasks.length > 1) {
      const selectedParentTasks = updatedTasks
        .map((task) =>
          gridData.find(
            (item) => item.ParentTask?.ParentTaskId === task.ParentTaskId
          )
        )
        .filter((task) => task !== undefined);

      if (selectedParentTasks.length > 0) {
        const allTasksChecked = selectedParentTasks.every(
          (task) => task.ParentTask?.TaskIsChecked
        );
        if (allTasksChecked) {
          dispatch(
            remediationTrackerTasksReducerActions.setEnableCreateMergeTask(true)
          );
        } else {
          dispatch(
            remediationTrackerTasksReducerActions.setEnableCreateMergeTask(
              false
            )
          );
        }
      } else {
        dispatch(
          remediationTrackerTasksReducerActions.setEnableCreateMergeTask(false)
        );
      }
      dispatch(
        remediationTrackerTasksReducerActions.setEnableUnMergeTask(false)
      );
    } else {
      dispatch(
        remediationTrackerTasksReducerActions.setEnableCreateMergeTask(false)
      );
      dispatch(
        remediationTrackerTasksReducerActions.setEnableUnMergeTask(false)
      );
    }
  }, [
    remediationTrackerTasksState.GridData,
    remediationTrackerTasksState.SelectedTask,
  ]);

  const onParentTaskCheckBoxClickedCallBack = (
    parentTaskId: number,
    isSelected: boolean
  ) => {
    handleTaskSelectionChange(parentTaskId, 0, isSelected, true);
  };

  const onChildTaskCheckBoxClickedCallBack = (
    parentTaskId: number,
    childTaskId: number,
    isSelected: boolean
  ) => {
    handleTaskSelectionChange(parentTaskId, childTaskId, isSelected, false);
  };

  const onClickOpenViewDetailsPopupCallBack = (
    taskId: number,
    isParentTask: boolean
  ) => {
    if (taskId === 0) {
      dispatch(
        remediationTrackerTasksReducerActions.setViewDetailspopUpData({
          OpenPopup: false,
          Data: [],
        } as ViewDetailsPopupDataType)
      );

      return;
    }

    dispatch(
      getRemediationRTrackerTaskQuestionDetails({
        TaskId: taskId,
        IsParentTask: isParentTask,
      } as RemediationTrackerTaskQuestionsRequestDTO)
    );
  };

  const updateApprovalData = (
    gridData: RemediationTrackerTaskGridDataType[]
  ) => {
    const newApprovalData: ParentChildApprovalDTO[] = [];

    gridData.forEach((parentItem) => {
      const checkedParent = parentItem.ParentTask?.TaskIsChecked;
      const checkedChildren = (parentItem.ChildTask ?? []).filter(
        (child) => child?.TaskIsChecked
      );

      // Case 1: Parent is checked (add even if no children)
      if (checkedParent) {
        newApprovalData.push({
          ParentTaskId: parentItem.ParentTask.ParentTaskId,
          ChildTaskIdList: checkedChildren.map((child) => child.ChildTaskId),
        });
      }
      // Case 2: Parent not checked, but has checked children
      else if (checkedChildren.length > 0) {
        newApprovalData.push({
          ParentTaskId: parentItem.ParentTask.ParentTaskId,
          ChildTaskIdList: checkedChildren.map((child) => child.ChildTaskId),
        });
      }
    });

    setApprovalData(newApprovalData);
  };

  useEffect(() => {
    updateApprovalData(remediationTrackerTasksState.GridData);
  }, [remediationTrackerTasksState.GridData]);

  /**
   * show approve/reject task button
   * @returns
   */
  const showTaskApproveRejectButton = () =>
    (checkSystemFunctionRight(
      EnumSystemFunctions.RemTrackerTaskPage_Approval_For_SME_Review,
      EnumSystemFunctionTypes.ButtonAccess
    ) ||
      checkSystemFunctionRight(
        EnumSystemFunctions.RemTrackerTaskPage_Approval_For_Site_Review,
        EnumSystemFunctionTypes.ButtonAccess
      ) ||
      checkSystemFunctionRight(
        EnumSystemFunctions.RemTrackerTaskPage_Approval_For_Closure,
        EnumSystemFunctionTypes.ButtonAccess
      )) &&
    approvalData?.length > 0;

  /**
   * full screen approve reject butoon
   * @returns
   */
  const shouldHideApproveRejectButton = () =>
    !(
      (approvalData?.length ?? 0) > 0 &&
      (remediationTrackerTasksPageState.IsFullScreen ?? false)
    );

  return (
    <div
      className="content-section-card rem-tracker top-main-padding"
      ref={wrapperCard}
    >
      <Grid container>
        <div
          className="flex--container fx-wrap width100-p top-main-border rem-btn-wrap"
          ref={searchRef}
        >
          <div className="flex__item--inherit pr-10 pl-10">
            <h2>
              <Button
                aria-label="back"
                className="sub-head-back-btn"
                onClick={BacktnOnclick}
                title="Back to home page"
              >
                {/* <ArrowLeft2 size="24" variant="Outline" /> */}
                <ArrowBackIosNewOutlinedIcon className="" />
                <span className="body-bold secondary-color">Back</span>
              </Button>
            </h2>
          </div>
          <div
            className="global-header-wrap rem-trak-head-res"
            ref={mainHeading}
          >
            <h1 className="page_title">Remediation Tracker</h1>
          </div>
          <div className="flex__item search-bar--small mr-10 pr-20 fx-around">
            <Paper
              component="form"
              sx={{
                p: "2px 4px",
                display: "flex",
                alignItems: "center",
                width: "100%",
              }}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <InputBase
                value={
                  remediationTrackerTasksPageState?.TaskSearchParameter
                    ?.BasicSearchValue ?? ""
                }
                onChange={(event) => {
                  onChangeSearchName(event.target?.value);
                }}
                onKeyPress={onKeyPressSearchName}
                sx={{ ml: 1, flex: 1 }}
                placeholder="Search Remediation Tasks"
                inputProps={{ "aria-label": "TaskName" }}
                // type="search"
              />

              {isMouseOver &&
                remediationTrackerTasksPageState?.TaskSearchParameter
                  ?.BasicSearchValue &&
                remediationTrackerTasksPageState?.TaskSearchParameter
                  ?.BasicSearchValue?.length > 0 && (
                  <Tooltip title="Clear" placement={"left-end"}>
                    <IconButton
                      className="mr-0"
                      onClick={() => onChangeSearchName("")}
                    >
                      <CloseIcon
                        style={{ color: "#219ebc", fontSize: "20px" }}
                      />
                    </IconButton>
                  </Tooltip>
                )}
              <Tooltip title="Search" placement={"left-end"}>
                <IconButton
                  type="button"
                  sx={{ p: "10px" }}
                  aria-label="search"
                  className="m-0"
                  onClick={() => {
                    serachBtnClick(false);
                  }}
                >
                  <SearchNormal1
                    variant="Outline"
                    className="ico-secondary"
                    size={18}
                  />
                </IconButton>
              </Tooltip>
              <Button
                className="ternery-btn-small adv-filter-btn"
                disableElevation
                size="small"
                variant="outlined"
                startIcon={<Filter variant="Outline" size={20} />}
                onClick={onclickAdvanceSearchOpen}
              >
                Advanced filters
              </Button>

              {showHideClearBtn() &&
                remediationTrackerTasksPageState.TaskFilteredSummary?.length >
                  0 && (
                  <Button
                    onClick={onclickRemoveAllFilters}
                    className={`danger-btn-small `}
                    disableElevation
                    size="small"
                    variant="outlined"
                    startIcon={<BrushBig variant="Outline" />}
                  >
                    Clear filters
                  </Button>
                )}
            </Paper>
          </div>

          {!(remediationTrackerTasksPageState.IsFullScreen ?? false) && (
            <div className="flex__item--inherit text-right sub-header-btn-wrap pr-10 pl-10">
              {showTaskApproveRejectButton() && (
                <Tooltip title="Reject selected task(s)">
                  <Button
                    className="primary-btn-small"
                    disableElevation
                    variant="outlined"
                    startIcon={<Slash variant="Outline" size={20} />}
                    onClick={onclickRejectRemediationTrackerTask}
                    // disabled={
                    //   props?.ViewRemediationTrackerTaskTableToolBarButtonProps
                    //     ?.DisabledRejectButton
                    // }
                  >
                    Reject
                  </Button>
                </Tooltip>
              )}

              {showTaskApproveRejectButton() && (
                <Tooltip title="Approve selected task(s)">
                  <Button
                    className="primary-btn-small"
                    disableElevation
                    variant="outlined"
                    startIcon={<TickCircle variant="Outline" size={20} />}
                    onClick={onclickApproveRemediationTrackerTask}
                    // disabled={
                    //   props?.ViewRemediationTrackerTaskTableToolBarButtonProps
                    //     ?.DisabledApproveButton
                    // }
                  >
                    Approve
                  </Button>
                </Tooltip>
              )}
            </div>
          )}
        </div>
        <Grid container className="rem-bottom-content-wra mt-10">
          {/* <Grid container>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={
                      remediationTrackerTasksPageState
                        .TaskSearchParameter
                        
                        .ShowTasksAssignedToMe
                    }
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                      handleFilterCheckboxChange(
                        "ShowTasksAssignedToMe",
                        event.target.checked
                      )
                    }
                  />
                }
                label="Tasks(s) Assigned to me"
              />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={
                      remediationTrackerTasksPageState
                        .TaskSearchParameter
                        
                        .ShowTasksPendingMyApproval
                    }
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                      handleFilterCheckboxChange(
                        "ShowTasksPendingMyApproval",
                        event.target.checked
                      )
                    }
                  />
                }
                label="Tasks(s) Pending my approval"
              />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={
                      remediationTrackerTasksPageState
                        .TaskSearchParameter
                        .ShowCompletedTasks
                    }
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                      handleFilterCheckboxChange(
                        "ShowCompletedTasks",
                        event.target.checked
                      )
                    }
                  />
                }
                label="Completed Tasks(s)"
              />
            </FormGroup>
          </Grid> */}
          <Grid container></Grid>
          {/* <Grid container spacing={2} style={{ paddingTop: 10 }}>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            className="pt-0 justify-right"
          ></Grid>
        </Grid> */}
          {/* filter strat */}
          {/* <div className="main-content-inner"> */}
          {remediationTrackerTasksPageState?.TaskFilteredSummary?.length >
            0 && (
            <div
              className="flex--container advance-filter-token mb-10 pl-10 mt-5"
              ref={advanceFilter}
            >
              <span className="body5 mr-5">Filtered condition(s):</span>
              {remediationTrackerTasksPageState?.TaskFilteredSummary?.map(
                (item) => {
                  return (
                    <div className="filter-icon" key={item.Label}>
                      <div
                        className="flex__item--inherit mr-5"
                        style={{ display: "inline-flex" }}
                      >
                        <span className="body5 mr-5 no-wrap">
                          {item.Label}:
                        </span>
                        <Tooltip title={item.Value}>
                          <span className="truncate" style={{ maxWidth: 135 }}>
                            {item.Value}
                          </span>
                        </Tooltip>
                      </div>
                      <IconButton
                        className="icon-btn-close clear-icon-align"
                        onClick={(e) => {
                          e.stopPropagation();
                          onClickRemoveFiltersCallBack(item);
                        }}
                      >
                        <CloseCircle size="15"></CloseCircle>
                      </IconButton>
                    </div>
                  );
                }
              )}
            </div>
          )}
          {/* filter end */}
          {/* check box filter strt */}
          {/* <Grid container ref={checkboxFilter}>
          <div className="checkbox-filter">
            <HPRCheckBox
              Id={"ShowTasksAssignedToMe"}
              Name={"ShowTasksAssignedToMe"}
              Label={"Show Task(s) assigned to me"}
              checked={
                remediationTrackerTasksPageState
                  .TaskSearchParameter
                  .ShowTasksAssignedToMe
              }
              onCheckBoxChange={handleFilterCheckboxChange}
              ClassName={"inline-single-element"}
            ></HPRCheckBox>
            <HPRCheckBox
              Id={"ShowTasksPendingMyApproval"}
              Name={"ShowTasksPendingMyApproval"}
              Label={"Show Task(s) pending my approval"}
              checked={
                remediationTrackerTasksPageState
                  .TaskSearchParameter
                  .ShowTasksPendingMyApproval
              }
              onCheckBoxChange={handleFilterCheckboxChange}
              ClassName={"inline-single-element"}
            ></HPRCheckBox>
            <HPRCheckBox
              Id={"ShowCompletedTasks"}
              Name={"ShowCompletedTasks"}
              Label={"Show Closed Task(s)"}
              checked={
                remediationTrackerTasksPageState
                  .TaskSearchParameter
                  .ShowCompletedTasks
              }
              onCheckBoxChange={handleFilterCheckboxChange}
              ClassName={"inline-single-element"}
            ></HPRCheckBox>
          </div>
        </Grid> */}
          {/* check box filter end */}
          {/* Status */}
          {remediationTrackerTasksPageState?.TaskAssessmentSummary?.length >
            0 && (
            <Grid
              container
              // style={{
              //   display: `${
              //     remediationTrackerTasksPageState?.Data?.Data?.length > 0
              //       ? "flex"
              //       : "none"
              //   }`,
              // }}
              ref={assessmentTypeRef}
              className="pl-10 pt-5 assessment-type-wrap"
            >
              <div
                className={`standart-status-change mb-5 d-flex`}
                style={{
                  borderRight: "unset",
                  borderLeft: "unset",
                  zIndex: "10",
                }}
              >
                <span className="mr-5 fx flex-right type-name">Type: </span>
                <Grid container className="status-wrp">
                  {remediationTrackerTasksPageState?.TaskAssessmentSummary?.map(
                    (item) => {
                      return (
                        <div
                          className="standards-status"
                          key={`AssessmentType_${item.GroupId}`}
                          onClick={() => {
                            handleSummaryClick(
                              "AssessmentTypeGroupId",
                              item.GroupId
                            );
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <span
                            className={`status-color all ${
                              item.GroupId ===
                              remediationTrackerTasksPageState
                                .TaskSearchParameter?.AssessmentTypeGroupId
                                ? "active"
                                : ""
                            }`}
                          >
                            {item.Code}
                          </span>
                        </div>
                      );
                    }
                  )}
                </Grid>
              </div>
            </Grid>
          )}

          <Grid
            container
            style={{
              visibility: `${
                remediationTrackerTasksPageState?.GridData?.length > 0
                  ? "visible"
                  : "hidden"
              }`,
            }}
            ref={statusFilter}
            className="pl-10 pt-5"
          >
            {remediationTrackerTasksPageState?.TaskStatusSummaryCount?.filter(
              (filter) => filter.NoOfTaskCount > 0
            ).length > 0 && (
              <div
                className={`standart-status-change d-flex`}
                style={{
                  borderRight: "unset",
                  borderLeft: "unset",
                  zIndex: "10",
                  flexWrap: "nowrap",
                }}
              >
                <div className="mr-5 type-name d-flex flex-right">Status: </div>
                <div className="mr-5 fx flex-wrap_wrap status-wrp">
                  {remediationTrackerTasksPageState?.TaskStatusSummaryCount?.filter(
                    (filter) => filter.NoOfTaskCount > 0
                  ).map((item) => {
                    return (
                      <div
                        className="standards-status"
                        key={`Status_${item.Id}`}
                        onClick={() => {
                          handleSummaryClick("StatusId", item.Id);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <span
                          className={`status-color ${
                            item.Id === 0
                              ? "common"
                              : getStatusColorClass(item.Id)
                          } ${
                            item.Id ===
                            remediationTrackerTasksPageState.TaskSearchParameter
                              ?.StatusId
                              ? "active"
                              : ""
                          }`}
                        >
                          {item.Description}
                          {item.NoOfTaskCount || item.NoOfTaskCount === 0
                            ? ` (${item.NoOfTaskCount})`
                            : ""}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </Grid>

          {/* Status*/}
          <Grid container>
            {gridHeight > 0 && (
              <Grid
                item
                xs={12}
                style={{ height: gridHeight }}
                className="grid-height pl-10 pr-10"
              >
                <ViewRemediationTrackerTaskTable
                  GridData={taskGridDataList}
                  GridHeight={gridHeight}
                  SearchValue={
                    remediationTrackerTasksPageState?.TaskSearchParameter
                      ?.BasicSearchValue ?? ""
                  }
                  AdvanceFilterHeight={advanceFilterHeight}
                  RemediationTrackerTaskList={
                    []
                    //remediationTrackerTasksPageState?.Data?.Data
                  }
                  ShowDataLoading={remediationTrackerTasksState.DataLoading}
                  IsFullScreen={
                    remediationTrackerTasksPageState.IsFullScreen ?? false
                  }
                  FilterColumnWise={
                    remediationTrackerTasksState.TaskSearchParameter
                      ?.FilterColumnWise ?? false
                  }
                  ClearExpandedRows={
                    remediationTrackerTasksState?.ClearExpandedRows
                  }
                  ViewDetailsPopUpData={
                    remediationTrackerTasksState.ViewDetailsPopUpData
                  }
                  PaginationProps={
                    {
                      TotalRecordsCount:
                        remediationTrackerTasksPageState?.TaskSearchParameter
                          ?.TotalRecordsCount,
                      PageSize:
                        remediationTrackerTasksState.TaskSearchParameter
                          ?.GridPageSize,
                      SelectedPage:
                        remediationTrackerTasksState.TaskSearchParameter
                          ?.SelectedPage,
                      TaskStatusSummaryCount:
                        remediationTrackerTasksPageState.TaskStatusSummaryCount,
                      TaskFilteredSummary:
                        remediationTrackerTasksPageState?.TaskFilteredSummary,
                      onPaginationChangeCallBack: onPaginationCallBack,
                    } as ViewRemediationTrackerTaskListPagination
                  }
                  ViewRemediationTrackerTaskListToolBar={
                    {
                      ViewRemediationTrackerTaskListSortByOptions: {
                        SortByItemList: sortByItemList,
                        InitialSortByState:
                          remediationTrackerTasksPageState?.TaskSearchParameter
                            ?.RemediationTrackerTaskSortBy,
                        onChangeSortBy: onChangeRemediationTrackerTaskSortBy,
                      },
                      ViewRemediationTrackerTaskListToolbarReportProps: {
                        ReportViewer: {
                          ReportSearchParameterForRemediation: {
                            ...remediationTrackerTasksPageState?.TaskSearchParameter,
                          },
                          IsReportDataFound:
                            remediationTrackerTasksPageState?.GridData?.length >
                            0,
                        },
                        ShowReport: true,
                      },
                      ViewRemediationTrackerTaskListToolbarColumnProps: {
                        ShowColumnOption: true,
                        ListColumns:
                          remediationTrackerTasksState.ColumnOptions ??
                          listOfColumns,
                      },
                      ViewRemediationTrackerTaskTableToolBarButtonProps: {
                        HideApproveButton: shouldHideApproveRejectButton(),
                        HideRejectButton: shouldHideApproveRejectButton(),
                        HideCreateMergeTaskButton:
                          !remediationTrackerTasksState.IsEnableCreateMergeTask,
                        HideUnMergeTaskButton:
                          !remediationTrackerTasksState.IsEnableUnMergeTask,
                        onClickApproveButton:
                          onclickApproveRemediationTrackerTask,
                        onClickRejectButton:
                          onclickRejectRemediationTrackerTask,
                        onClickCreateMergeTaskButton: onclickCreateMergeNewTask,
                        onClickCreateUnMergeTaskButton: onclickUnMergeTask,
                      },
                      FilterCheckboxsProps: {
                        CheckedTasksAssignedToMe:
                          remediationTrackerTasksPageState.TaskSearchParameter
                            .ShowTasksAssignedToMe,
                        CheckedTasksPendingMyApproval:
                          remediationTrackerTasksPageState.TaskSearchParameter
                            .ShowTasksPendingMyApproval,
                        CheckedCompletedTasks:
                          remediationTrackerTasksPageState.TaskSearchParameter
                            .ShowCompletedTasks,
                        CheckedCancelledTasks:
                          remediationTrackerTasksPageState.TaskSearchParameter
                            .ShowCancelledTasks,
                        onFilterCheckboxChange: handleFilterCheckboxChange,
                      },
                    } as ViewRemediationTrackerTaskListToolBarProps
                  }
                  CallbackFunction={{
                    onClickViewOrEditTask: onClickViewOrEditTaskCallBack,
                    onClickRefreshBtnCallBack: onClickRefreshBtnCallBack,
                    onParentTaskCheckBoxClicked:
                      onParentTaskCheckBoxClickedCallBack,
                    onChildTaskCheckBoxClicked:
                      onChildTaskCheckBoxClickedCallBack,
                    onclickRemediationTrackerTaskDetails:
                      onclickRemediationTrackerTaskDetailsCallBack,
                    onDeleteRemediationTrackerTask:
                      deleteRemediationTrackerTaskCallBack,
                    onclickAddNewTaskCallBack: onclickAddNewTaskCallBack,
                    onChangeSortByCallBack:
                      onChangeRemediationTrackerTaskSortBy,
                    onChangeFullScreenGlobalFilterCallBack: (searchValue) => {
                      onChangeSearchName(searchValue);
                    },
                    onKeyPressFullScreenGlobalFilterCallBack:
                      onKeyPressSearchName,
                    onFullScreenGlobalFilterBtnClickCallBack() {
                      serachBtnClick(false);
                    },
                    onIsFullScreenChangeCallBack: onIsFullScreenChangeCallBack,
                    onCheckAllCheckBoxClickedCallBack:
                      onCheckAllCheckBoxClickedCallBack,
                    onChangeColumnOptions: onChangeColumnOptionsCallBack,
                    onClickOpenViewDetailsPopup:
                      onClickOpenViewDetailsPopupCallBack,
                  }}
                />

                {/* <ViewRemediationTrackerTaskList
                  GridHeight={gridHeight}
                  RemediationTrackerTaskList={
                    remediationTrackerTasksPageState?.Data?.Data
                  }
                  PaginationProps={
                    {
                      TotalRecordsCount:
                        remediationTrackerTasksPageState?.Data
                          ?.TotalRecordsCount,
                      PageSize: remediationTrackerTasksPageState.Data?.PageSize,
                      SelectedPage:
                        remediationTrackerTasksPageState.Data?.SelectedPage,
                      TaskStatusSummaryCount:
                        remediationTrackerTasksPageState.TaskStatusSummaryCount,
                      TaskFilteredSummary:
                        remediationTrackerTasksPageState?.TaskFilteredSummary,
                      onPaginationChangeCallBack: onPaginationCallBack,
                    } as ViewRemediationTrackerTaskListPagination
                  }
                  CallbackFunction={
                    {
                      onClickViewOrEditTask: onClickViewOrEditTaskCallBack,
                      onCheckBoxClicked: onGridCheckBoxClicked,
                      onclickAddNewTaskCallBack: onclickAddNewTaskCallBack,
                      onclickRemediationTrackerTaskDetails:
                        onclickRemediationTrackerTaskDetailsCallBack,
                      onDeleteRemediationTrackerTask:
                        deleteRemediationTrackerTaskCallBack,
                      onClickRemoveFiltersCallBack:
                        onClickRemoveFiltersCallBack,
                    } as ViewTaskListCallBackFunctionType
                  }
                  HideAddTaskBtn={
                    remediationTrackerTasksState.SelectedRemediationTrackerTask
                      ?.length >= 1
                  }
                  ViewRemediationTrackerTaskListToolBar={
                    {
                      ViewRemediationTrackerTaskListPerOptions: {
                        Id: "",
                        Name: "",
                        defaultValue: 15,
                        PerPageItemList: perPageList,
                        onChangePerPage: onChangePageSize,
                      } as ViewRemediationTrackerTaskListPerPageOptionsProps,
                      ViewRemediationTrackerTaskListSortByOptions: {
                        SortByItemList: sortByItemList,
                        InitialSortByState: {
                          Label: "Location",
                          Value:
                            EnumRemediationTrackerTaskColumnType.Location.toString(),
                          SortType: EnumSortTypes.Ascending,
                        },
                        onChangeSortBy: onChangeRemediationTrackerTaskSortBy,
                      },

                      ViewRemediationTrackerTaskListToolbarReportProps: {
                        ReportViewer: {
                          ReportSearchParameter:
                            remediationTrackerTasksState?.TaskSearchParameter,
                          IsReportDataFound:
                            remediationTrackerTasksPageState?.Data?.Data
                              ?.length > 0,
                        },
                        ShowReport: checkSystemFunctionRight(
                          EnumSystemFunctions.RemTrackerTasksPage_Export,
                          EnumSystemFunctionTypes.ButtonAccess
                        ),

                        // remediationTrackerTasksPageState?.Data?.Data?.length >
                        // 0,
                      },

                      ViewRemediationTrackerTaskListToolbarColumnProps: {
                        // ShowColumnOption: true,
                        ListColumns: listOfColumns,
                      },
                    } as ViewRemediationTrackerTaskListToolBarProps
                  }
                /> */}
              </Grid>
            )}
          </Grid>
        </Grid>
        {/* </div> */}
        {/* <Grid container>
            {gridHeight && gridHeight > 0 && (
              <Grid item xs={12} style={{ height: gridHeight }}>
                <HPRDataGrid
                  Columns={columns}
                  Data={remediationTrackerTasksPageState?.Data?.Data}
                  TotalRecordsCount={
                    remediationTrackerTasksPageState?.Data?.TotalRecordsCount
                  }
                  // Height={66}
                  // AutoHeight
                  onPaginationChangeCallBack={onPaginationCallBack}
                  SelectedPage={
                    remediationTrackerTasksPageState.Data?.SelectedPage
                  }
                  MenuFunctions={{
                    onChangeSortBy: onChangeRemediationTrackerTaskSortBy,
                  }}
                  showMenu={true}
                  GridPagination={{
                    defaultValue:
                      remediationTrackerTasksPageState.Data?.PageSize,
                    onChangePerPage: onChangePageSize,
                    HidePerPage: false,
                    PerPageItemList: [
                      {
                        Label: "5",
                        Value:
                          EnumListShowRowCountList.ListShowRowCountPerPage_1.toString(),
                      },
                      {
                        Label: "10",
                        Value:
                          EnumListShowRowCountList.ListShowRowCountPerPage_2.toString(),
                      },
                      {
                        Label: "15",
                        Value:
                          EnumListShowRowCountList.ListShowRowCountPerPage_3.toString(),
                      },
                      {
                        Label: "20",
                        Value:
                          EnumListShowRowCountList.ListShowRowCountPerPage_4.toString(),
                      },
                      {
                        Label: "25",
                        Value:
                          EnumListShowRowCountList.ListShowRowCountPerPage_5.toString(),
                      },
                    ] as DropDownDTO[],
                  }}
                  PageSize={remediationTrackerTasksPageState.Data?.PageSize}
                  HPRDataGridToolbarProps={
                    {
                      HPRDataGridToolbarColumnProps: {
                        ShowColumnOption: true,
                      } as HPRDataGridToolbarColumnProps,
                      HPRDataGridToolbarReportProps: {
                        ShowReport: true,
                        ReportType:
                          EnumReportType.RemediationTrackerTasksReport,
                        ReportViewer: {
                          ReportType:
                            EnumReportType.RemediationTrackerTasksReport,
                          ReportSearchParameter:
                            remediationTrackerTasksState?.TaskSearchParameter,
                        },
                      } as HPRDataGridToolbarReportProps,
                      ShowTotalRecordsCount: true,
                    } as HPRDataGridToolbarProps
                  }
                ></HPRDataGrid>
              </Grid>
            )}
          </Grid> */}

        <Modal
          className="modal-outter sub-form-section"
          open={openAdvanceSearchModel}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          //onClose={onclickAdvanceSearchClose}
        >
          <Box className="advance-search-modal" sx={style}>
            <div className="modal-header">
              <h1>Advanced filters</h1>
            </div>
            <div
              className="modal-content flex-wrap mt-10"
              style={{ height: "auto" }}
            >
              <Grid container>
                <Grid item xs={1} sm={1} md={1} lg={1}></Grid>
                <Grid item xs={10} sm={10} md={10} lg={10}>
                  {/* 1st row */}
                  <Grid container spacing={2} className="fx-align-center">
                    <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
                      <div className="form-group">
                        <HPRDropDownMultipleSelect
                          Id="SelectedLocationIdList"
                          Name="SelectedLocationIdList"
                          Label="Location"
                          Select={remediationTrackerTasksPageState?.TaskSearchParameter?.SelectedLocationIdList?.map(
                            (item) => item.toString()
                          )}
                          Items={
                            remediationTrackerTasksState?.DropDownListFilter
                              ?.LocationDropDownList
                          }
                          onMultipleSelectDropDownChange={(
                            selectOptions: Array<DropDownDTO>,
                            selectedValues: Array<string>
                          ) =>
                            handleLocationStandardDropDownListChange(
                              "SelectedLocationIdList",
                              selectedValues
                            )
                          }
                          IsSearchable
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
                      <div className="form-group">
                        <HPRDropDownMultipleSelect
                          Id="SelectedInspectionIdList"
                          Name="SelectedInspectionIdList"
                          Label="Inspection Name"
                          Select={remediationTrackerTasksPageState?.TaskSearchParameter?.SelectedInspectionIdList?.map(
                            (item) => item.toString()
                          )}
                          Items={
                            remediationTrackerTasksState?.DropDownListFilter
                              ?.InspectionDropDownList
                          }
                          onMultipleSelectDropDownChange={(
                            selectOptions: Array<DropDownDTO>,
                            selectedValues: Array<string>
                          ) =>
                            handleLocationStandardDropDownListChange(
                              "SelectedInspectionIdList",
                              selectedValues
                            )
                          }
                          IsSearchable
                        />
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
                      <div className="form-group">
                        <HPRDropDownMultipleSelect
                          Id="SelectedStandardIdList"
                          Name="SelectedStandardIdList"
                          Label="Standard Name"
                          Select={remediationTrackerTasksPageState?.TaskSearchParameter?.SelectedStandardIdList?.map(
                            (item) => item.toString()
                          )}
                          Items={
                            remediationTrackerTasksState?.DropDownListFilter
                              ?.StandardDropDownList
                          }
                          onMultipleSelectDropDownChange={(
                            selectOptions: Array<DropDownDTO>,
                            selectedValues: Array<string>
                          ) =>
                            handleLocationStandardDropDownListChange(
                              "SelectedStandardIdList",
                              selectedValues
                            )
                          }
                          IsSearchable
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
                      <div className="form-group">
                        <HPRTextBox
                          Id="Q_No"
                          Name="QuestionNumber"
                          Label="Q.No"
                          Value={
                            remediationTrackerTasksPageState
                              ?.TaskSearchParameter?.QuestionNumber
                          }
                          Type={EnumTextBoxType.Search}
                          onTextBoxChange={onSearchTextBoxChange}
                          TextLength={5}
                          InputProps={{ maxLength: 5 }}
                        />
                      </div>
                    </Grid>
                  </Grid>

                  {/* 2nd row */}
                  <Grid container spacing={2} className="fx-align-center">
                    <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
                      <div className="form-group">
                        <HPRTextBox
                          Id="TaskName"
                          Name="TaskName"
                          Label="Task Description"
                          Value={
                            remediationTrackerTasksPageState
                              ?.TaskSearchParameter?.TaskName
                          }
                          Type={EnumTextBoxType.Search}
                          onTextBoxChange={onSearchTextBoxChange}
                          TextLength={750}
                          InputProps={{ maxLength: 750 }}
                        />
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
                      <div className="form-group">
                        <HPRDropDownMsGraphMultipleSelect
                          Id="SelectedActionOwnerIdList"
                          Name="SelectedActionOwnerIdList"
                          Label="Task Action Owner"
                          Select={remediationTrackerTasksPageState?.TaskSearchParameter?.SelectedActionOwnerIdList?.map(
                            (item) => item
                          )}
                          Url="RemediationTrackerTasks/GetActionOwnerListForDropDown"
                          Items={
                            remediationTrackerTasksPageState?.DropDownListFilter
                              ?.ActionOwnerDropDownList
                          }
                          onMultipleSelectDropDownChange={(
                            selectOptions: Array<DropDownDTO>,
                            selectedValues: Array<string>
                          ) =>
                            handleActionOwnerStringDropDownListChange(
                              "SelectedActionOwnerIdList",
                              selectOptions,
                              selectedValues
                            )
                          }
                          IsSearchable
                        />
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
                      <div className="form-group">
                        <HPRDropDownMultipleSelect
                          Id="SelectedStatusIdList"
                          Name="SelectedStatusIdList"
                          Label="Task Status"
                          Select={remediationTrackerTasksPageState?.TaskSearchParameter?.SelectedStatusIdList?.map(
                            (item) => item.toString()
                          )}
                          Items={
                            remediationTrackerTasksState?.DropDownListFilter
                              ?.StatusDropDownList
                          }
                          onMultipleSelectDropDownChange={(
                            selectOptions: Array<DropDownDTO>,
                            selectedValues: Array<string>
                          ) =>
                            handleLocationStandardDropDownListChange(
                              "SelectedStatusIdList",
                              selectedValues
                            )
                          }
                          IsSearchable
                        />
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
                      <div className="form-group">
                        <HPRDropDownMultipleSelect
                          Id="SelectedPriorityIdList"
                          Name="SelectedPriorityIdList"
                          Label="Task Priority"
                          Select={remediationTrackerTasksPageState?.TaskSearchParameter?.SelectedPriorityIdList?.map(
                            (item) => item.toString()
                          )}
                          Items={
                            remediationTrackerTasksState?.DropDownListFilter
                              ?.PriorityDropDownList
                          }
                          onMultipleSelectDropDownChange={(
                            selectOptions: Array<DropDownDTO>,
                            selectedValues: Array<string>
                          ) =>
                            handleLocationStandardDropDownListChange(
                              "SelectedPriorityIdList",
                              selectedValues
                            )
                          }
                          IsSearchable
                        />
                      </div>
                    </Grid>
                  </Grid>

                  {/* 3rd row */}
                  <Grid container spacing={2} className="fx-align-center">
                    <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
                      <div className="form-group">
                        <HPRDropDownMultipleSelect
                          Id="SelectedIsCapexRequiredIdList"
                          Name="SelectedIsCapexRequiredIdList"
                          Label="Is CAPEX Required"
                          Select={remediationTrackerTasksPageState?.TaskSearchParameter?.SelectedIsCapexRequiredIdList?.map(
                            (item) => item.toString()
                          )}
                          Items={
                            remediationTrackerTasksState?.DropDownListFilter
                              ?.IsCapexRequiredDropDownList
                          }
                          onMultipleSelectDropDownChange={(
                            selectOptions: Array<DropDownDTO>,
                            selectedValues: Array<string>
                          ) =>
                            handleLocationStandardDropDownListChange(
                              "SelectedIsCapexRequiredIdList",
                              selectedValues
                            )
                          }
                          IsSearchable
                        />
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
                      <div className="form-group">
                        <HPRTextBox
                          Id="CapexnumberAndName"
                          Name="CapexnumberAndName"
                          Label="CAPEX Number & Name"
                          Value={
                            remediationTrackerTasksPageState
                              ?.TaskSearchParameter?.CapexnumberAndName
                          }
                          Type={EnumTextBoxType.Search}
                          onTextBoxChange={onSearchTextBoxChange}
                          TextLength={100}
                          InputProps={{ maxLength: 100 }}
                        />
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
                      <div className="form-group">
                        <HPRDropDownMultipleSelect
                          Id="SelectedCapexStatusIdList"
                          Name="SelectedCapexStatusIdList"
                          Label="CAPEX Status"
                          Select={remediationTrackerTasksPageState?.TaskSearchParameter?.SelectedCapexStatusIdList?.map(
                            (item) => item.toString()
                          )}
                          Items={
                            remediationTrackerTasksState?.DropDownListFilter
                              ?.CapexStatusDropDownList
                          }
                          onMultipleSelectDropDownChange={(
                            selectOptions: Array<DropDownDTO>,
                            selectedValues: Array<string>
                          ) =>
                            handleLocationStandardDropDownListChange(
                              "SelectedCapexStatusIdList",
                              selectedValues
                            )
                          }
                          IsSearchable
                        />
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
                      <div className="form-group">
                        <HPRTextBox
                          Id="CapexamountRequired"
                          Name="CapexamountRequired"
                          Label="CAPEX Amount Required (M$)"
                          Value={
                            remediationTrackerTasksPageState?.TaskSearchParameter?.CapexamountRequired?.toString() ??
                            ""
                          }
                          Type={EnumTextBoxType.Search}
                          onTextBoxChange={onSearchTextBoxChange}
                          ComponentProps={{
                            inputComponent: NumericFormatCustom as any,
                          }}
                          InputProps={{ maxLength: 12 }}
                        />
                      </div>
                    </Grid>
                  </Grid>
                  {/* <Grid
                      container
                      spacing={2}
                      className="fx-align-center"
                    ></Grid> */}

                  {/* 4th row */}
                  <Grid container spacing={2} className="fx-align-center">
                    <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
                      <div className="form-group mb-0">
                        <HPRDatePicker
                          Name={"FromDueDate"}
                          Label={"Task Due Date(From)"}
                          ClassName="width100-p"
                          Value={
                            remediationTrackerTasksPageState
                              ?.TaskSearchParameter?.FromDueDate
                          }
                          DefaultValue={dayjs(new Date()).toString()}
                          onDateChange={onDueDateChange}
                          IsDisabledDate={(currentDate) => {
                            if (currentDate?.year() < 2023) {
                              return true;
                            } else {
                              const toDate =
                                remediationTrackerTasksPageState
                                  ?.TaskSearchParameter?.ToDueDate;
                              return (
                                dayjs(toDate).isValid() &&
                                currentDate.isAfter(
                                  dayjs(toDate).subtract(0, "day")
                                )
                              );
                            }
                          }}
                          Type={EnumDateType.DateOnly}
                        ></HPRDatePicker>
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
                      <div className="form-group mb-0">
                        <HPRDatePicker
                          Name={"ToDueDate"}
                          Label={"Task Due Date(To)"}
                          ClassName="width100-p"
                          Value={
                            remediationTrackerTasksPageState
                              ?.TaskSearchParameter?.ToDueDate
                          }
                          DefaultValue={dayjs(new Date()).toString()}
                          onDateChange={onDueDateChange}
                          IsDisabledDate={(currentDate) => {
                            if (currentDate?.year() < 2023) {
                              return true;
                            } else {
                              const fromDate =
                                remediationTrackerTasksPageState
                                  ?.TaskSearchParameter?.FromDueDate;
                              return (
                                dayjs(fromDate).isValid() &&
                                currentDate.isBefore(
                                  dayjs(fromDate).subtract(0, "day")
                                )
                              );
                            }
                          }}
                          Type={EnumDateType.DateOnly}
                        ></HPRDatePicker>
                      </div>
                    </Grid>
                    {/* <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
                        <div className="form-group">
                          <HPRDropDownMultipleSelect
                            Id="SelectedApproverIdList"
                            Name="SelectedApproverIdList"
                            Label="Task Closure Approver"
                            Select={remediationTrackerTasksPageState?.TaskSearchParameter?.SelectedApproverIdList?.map(
                              (item) => item.toString()
                            )}
                            Items={
                              remediationTrackerTasksState?.DropDownListFilter
                                ?.ActionOwnerDropDownList
                            }
                            onMultipleSelectDropDownChange={(
                              selectOptions: Array<DropDownDTO>,
                              selectedValues: Array<string>
                            ) =>
                              handleLocationStandardDropDownListChange(
                                "SelectedApproverIdList",
                                selectedValues
                              )
                            }
                            IsSearchable
                          />
                        </div>
                      </Grid> */}

                    <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
                      <div className="form-group">
                        <HPRDropDownMultipleSelect
                          Id="SelectedAreaOwnerTypeIdList"
                          Name="SelectedAreaOwnerTypeIdList"
                          Label="Category"
                          Select={remediationTrackerTasksPageState?.TaskSearchParameter?.SelectedAreaOwnerTypeIdList?.map(
                            (item) => item.toString()
                          )}
                          Items={
                            remediationTrackerTasksState?.DropDownListFilter
                              ?.AreaOwnerTypeDropDownList
                          }
                          onMultipleSelectDropDownChange={(
                            selectOptions: Array<DropDownDTO>,
                            selectedValues: Array<string>
                          ) =>
                            handleLocationStandardDropDownListChange(
                              "SelectedAreaOwnerTypeIdList",
                              selectedValues
                            )
                          }
                          IsSearchable
                        />
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
                      <div className="form-group">
                        <HPRDropDownMsGraphMultipleSelect
                          Id="SelectedPendingApproverIdList"
                          Name="SelectedPendingApproverIdList"
                          Label="Task Pending Approver"
                          Select={remediationTrackerTasksPageState?.TaskSearchParameter?.SelectedPendingApproverIdList?.map(
                            (item) => item
                          )}
                          //Url="RemediationTrackerTasks/GetPendingApproverListForDropDown"
                          Items={
                            remediationTrackerTasksState?.DropDownListFilter
                              ?.PendingApproverDropDownList
                          }
                          onMultipleSelectDropDownChange={(
                            selectOptions: Array<DropDownDTO>,
                            selectedValues: Array<string>
                          ) =>
                            handlePendingApproverStringDropDownListChange(
                              "SelectedPendingApproverIdList",
                              selectOptions,
                              selectedValues
                            )
                          }
                          IsSearchable
                        />
                      </div>
                    </Grid>
                  </Grid>

                  {/* 5th row */}
                  <Grid container spacing={2} className="fx-align-center">
                    <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
                      <div className="form-group">
                        <HPRTextBox
                          Id="Ernumber"
                          Name="Ernumber"
                          Label="ER Number"
                          Value={
                            remediationTrackerTasksPageState
                              ?.TaskSearchParameter?.Ernumber
                          }
                          Type={EnumTextBoxType.Search}
                          onTextBoxChange={onSearchTextBoxChange}
                          TextLength={50}
                          InputProps={{ maxLength: 50 }}
                        />
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={1} sm={1} md={1} lg={1}></Grid>
              </Grid>
            </div>
            <div className="modal-button-bar">
              <Button
                variant="contained"
                disableElevation
                onClick={onclickAdvanceSearchClose}
                startIcon={<CloseCircle variant="Outline" />}
                className="secondary-btn-small"
              >
                Close
              </Button>
              <Button
                variant="contained"
                disableElevation
                onClick={onclickRemoveAllAdvancedFilters}
                startIcon={<BrushBig variant="Outline" />}
                className="danger-btn-small"
              >
                Clear filters
              </Button>
              <Button
                variant="contained"
                disableElevation
                onClick={onclickAdvanceSearchbtn}
                startIcon={<TickCircle variant="Outline" />}
                className="primary-btn-small"
              >
                Apply filters
              </Button>
            </div>
          </Box>
        </Modal>
      </Grid>
    </div>
  );
};
export default RemediationTrackerTasksPage;
